/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Omgevingsbeleid API
 * 
        This API serves all the object that make up the policies 
        of a provincial government. 
        
 * OpenAPI spec version: 5.0.0
 */
export type WettelijkeTaakListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type WerkingsgebiedGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type WerkingsgebiedGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type WerkingsgebiedListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type WerkingsgebiedListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type VisieAlgemeenGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type VisieAlgemeenGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type VisieAlgemeenListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type VisieAlgemeenListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type VerplichtProgrammaListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type ProgrammaAlgemeenGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type ProgrammaAlgemeenGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type ProgrammaAlgemeenListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type ProgrammaAlgemeenListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type NationaalBelangListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type MaatregelGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type MaatregelGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type MaatregelListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type MaatregelListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedsprogrammaGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type GebiedsprogrammaGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedsprogrammaListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedsprogrammaListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedsaanwijzingGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type GebiedsaanwijzingGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedsaanwijzingListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedsaanwijzingListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedengroepGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type GebiedengroepGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedengroepListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedengroepListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type GebiedGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type GebiedListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type DocumentGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type DocumentGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type DocumentListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type DocumentListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidsregelGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type BeleidsregelGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidsregelListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidsregelListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidskeuzeGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type BeleidskeuzeGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidskeuzeGetAcknowledgedRelationListParams = {
    requested_by_us?: boolean
    acknowledged?: boolean | null
    show_inactive?: boolean
}

export type BeleidskeuzeListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidskeuzeListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidsdoelGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type BeleidsdoelGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidsdoelListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type BeleidsdoelListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type AmbitieGetListActiveModuleObjectsParams = {
    minimum_status: ModuleStatusCode
}

export type AmbitieGetModuleListLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type AmbitieListValidLineageTreeParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type AmbitieListValidLineagesParams = {
    filter_title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type UserGetSearchUsersParams = {
    role?: string | null
    query?: string | null
    active?: boolean | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type UserGetListUsersParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type StorageFileGetFilesListParams = {
    only_mine?: boolean
    filter_filename?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type SourceWerkingsgebiedenGetListWerkingsgebiedenParams = {
    title?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type SearchGetMssqlValidSearchParams = {
    query: string
    offset?: number | null
    limit?: number | null
}

export type SearchGetMssqlSearchParams = {
    query: string
    offset?: number | null
    limit?: number | null
}

export type PublicationsGetListPublicationsParams = {
    document_type?: DocumentType | null
    module_id?: number | null
    offset?: number | null
    limit?: number | null
}

export type PublicationVersionsGetListVersionsParams = {
    offset?: number | null
    limit?: number | null
}

export type PublicationTemplatesGetListTemplatesParams = {
    is_active?: boolean | null
    document_type?: DocumentType | null
    offset?: number | null
    limit?: number | null
}

export type PublicationPackagesGetListUnifiedPackagesParams = {
    environment_uuid?: string | null
    module_id?: number | null
    report_status?: ReportStatusType | null
    package_type?: PackageType | null
    document_type?: DocumentType | null
    publication_type?: PublicationType | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type PublicationEnvironmentsGetListEnvironmentsParams = {
    is_active?: boolean | null
    offset?: number | null
    limit?: number | null
}

export type PublicationAnnouncementsGetListAnnouncementsParams = {
    act_package_uuid?: string | null
    offset?: number | null
    limit?: number | null
}

export type PublicationAnnouncementReportsGetListAnnnouncementPackageReportsParams =
    {
        announcement_package_uuid?: string | null
        report_status?: ReportStatusType | null
        offset?: number | null
        limit?: number | null
    }

export type PublicationAnnouncementPackagesGetListAnnouncementPackagesParams = {
    announcement_uuid?: string | null
    package_type?: PackageType | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type PublicationActsGetListActsParams = {
    is_active?: boolean | null
    environment_uuid?: string | null
    document_type?: DocumentType | null
    procedure_type?: ProcedureType | null
    offset?: number | null
    limit?: number | null
}

export type PublicationActReportsGetListActPackageReportsParams = {
    act_package_uuid?: string | null
    report_status?: ReportStatusType | null
    offset?: number | null
    limit?: number | null
}

export type PublicationActPackagesPostAbortActPackageParams = {
    confirm?: boolean
}

export type PublicationActPackagesGetListActPackagesParams = {
    version_uuid?: string | null
    package_type?: PackageType | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type PublicationAojGetListAojParams = {
    offset?: number | null
    limit?: number | null
}

export type PublicModulesGetPublicListModulesParams = {
    offset?: number | null
    limit?: number | null
}

export type ObjectsDoListAllLatestParams = {
    object_types?: string[]
    owner_uuid?: string | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type ModulesGetListModuleObjectsParams = {
    object_types?: string[]
    owner_uuid?: string | null
    owner_type?: OwnerType
    minimum_status?: ModuleStatusCode | null
    only_active_modules?: boolean
    title?: string | null
    actions?: ModuleObjectActionFull[]
    module_id?: number | null
    offset?: number | null
    limit?: number | null
    sort_column?: string | null
    sort_order?: SortOrder | null
}

export type ModulesGetListModulesParams = {
    only_mine?: boolean
    filter_activated?: boolean | null
    filter_closed?: boolean | null
    filter_successful?: boolean | null
    filter_title?: string | null
    object_type?: string | null
    lineage_id?: number | null
    offset?: number | null
    limit?: number | null
    sort_column?: ModuleSortColumn | null
    sort_order?: SortOrder | null
}

export type InputGeoGetInputGeoWerkingsgebiedenHistoryParams = {
    title: string
    from_date?: string | null
}

export type InputGeoGetInputGeoListLatestWerkingsgebiedenParams = {
    offset?: number | null
    limit?: number | null
    sort_column?: InputGeoWerkingsgebiedenSortColumn | null
    sort_order?: SortOrder | null
}

export type GraphGetObjectGraphParams = {
    uuid: string
}

export type AuthenticationPostAuthResetPasswordParams = {
    password: string
    new_password: string
}

export interface WriteRelation {
    Description?: string
    Object_ID: number
    Object_Type: string
}

export interface WettelijkeTaakUUID {
    Object_ID?: number
    UUID?: string
}

export type WettelijkeTaakStaticStaticsOwner2 = UserShort | null

export type WettelijkeTaakStaticStaticsOwner1 = UserShort | null

export interface WettelijkeTaakStaticStatics {
    Owner_1?: WettelijkeTaakStaticStaticsOwner1
    Owner_2?: WettelijkeTaakStaticStaticsOwner2
}

export type WettelijkeTaakStaticPostStaticsOwner2UUID = string | null

export type WettelijkeTaakStaticPostStaticsOwner1UUID = string | null

export interface WettelijkeTaakStaticPostStatics {
    Owner_1_UUID?: WettelijkeTaakStaticPostStaticsOwner1UUID
    Owner_2_UUID?: WettelijkeTaakStaticPostStaticsOwner2UUID
}

export interface WettelijkeTaakMinimal {
    Code?: string
    Created_Date?: string
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type WettelijkeTaakFullStaticsOwner2 = UserShort | null

export type WettelijkeTaakFullStaticsOwner1 = UserShort | null

export interface WettelijkeTaakFullStatics {
    Owner_1?: WettelijkeTaakFullStaticsOwner1
    Owner_2?: WettelijkeTaakFullStaticsOwner2
}

export type WettelijkeTaakFullStartValidity = string | null

export type WettelijkeTaakFullModifiedBy = UserShort | null

export type WettelijkeTaakFullEndValidity = string | null

export type WettelijkeTaakFullCreatedBy = UserShort | null

export interface WettelijkeTaakFull {
    Beleidskeuzes?: ReadRelationShortBeleidskeuzeMinimal[]
    Code?: string
    Created_By?: WettelijkeTaakFullCreatedBy
    Created_Date?: string
    End_Validity?: WettelijkeTaakFullEndValidity
    Modified_By?: WettelijkeTaakFullModifiedBy
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    ObjectStatics?: WettelijkeTaakFullStatics
    Start_Validity?: WettelijkeTaakFullStartValidity
    Title?: string
    UUID?: string
    VerplichtProgrammas?: VerplichtProgrammaMinimal[]
    Weblink?: string
}

export type WettelijkeTaakEditWeblink = string | null

export type WettelijkeTaakEditTitle = string | null

export interface WettelijkeTaakEdit {
    Title?: WettelijkeTaakEditTitle
    Weblink?: WettelijkeTaakEditWeblink
}

export type WettelijkeTaakCreateStaticsOwner2UUID = string | null

export type WettelijkeTaakCreateStaticsOwner1UUID = string | null

export interface WettelijkeTaakCreateStatics {
    Owner_1_UUID?: WettelijkeTaakCreateStaticsOwner1UUID
    Owner_2_UUID?: WettelijkeTaakCreateStaticsOwner2UUID
}

export type WettelijkeTaakCreateWeblink = string | null

export interface WettelijkeTaakCreate {
    ObjectStatics?: WettelijkeTaakCreateStatics
    Title?: string
    Weblink?: WettelijkeTaakCreateWeblink
}

export interface WettelijkeTaakBasic {
    Code?: string
    Created_Date?: string
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
    Weblink?: string
}

export interface WerkingsgebiedUUID {
    Object_ID?: number
    UUID?: string
}

export interface WerkingsgebiedStatics {
    Cached_Title: string
    Code: string
    Object_ID: number
    Object_Type: string
}

export type WerkingsgebiedStaticStaticsOwner2 = UserShort | null

export type WerkingsgebiedStaticStaticsOwner1 = UserShort | null

export interface WerkingsgebiedStaticStatics {
    Owner_1?: WerkingsgebiedStaticStaticsOwner1
    Owner_2?: WerkingsgebiedStaticStaticsOwner2
}

export type WerkingsgebiedStaticPostStaticsOwner2UUID = string | null

export type WerkingsgebiedStaticPostStaticsOwner1UUID = string | null

export interface WerkingsgebiedStaticPostStatics {
    Owner_1_UUID?: WerkingsgebiedStaticPostStaticsOwner1UUID
    Owner_2_UUID?: WerkingsgebiedStaticPostStaticsOwner2UUID
}

export type WerkingsgebiedRelatedObjectShortTitle = string | null

export interface WerkingsgebiedRelatedObjectShort {
    Object_ID: number
    Object_Type: string
    Title: WerkingsgebiedRelatedObjectShortTitle
    UUID: string
    Werkingsgebied_Code: string
}

export interface WerkingsgebiedRelatedObjects {
    Module_Objects: WerkingsgebiedRelatedModuleObjectShort[]
    Valid_Objects: WerkingsgebiedRelatedObjectShort[]
}

export type WerkingsgebiedRelatedModuleObjectShortTitle = string | null

export type WerkingsgebiedRelatedModuleObjectShortModuleTitle = string | null

export type WerkingsgebiedRelatedModuleObjectShortModuleID = number | null

export interface WerkingsgebiedRelatedModuleObjectShort {
    Module_ID?: WerkingsgebiedRelatedModuleObjectShortModuleID
    Module_Title?: WerkingsgebiedRelatedModuleObjectShortModuleTitle
    Object_ID: number
    Object_Type: string
    Title: WerkingsgebiedRelatedModuleObjectShortTitle
    UUID: string
    Werkingsgebied_Code: string
}

export type WerkingsgebiedPatchTitle = string | null

export type WerkingsgebiedPatchDescription = string | null

export type WerkingsgebiedPatchAreaUUID = string | null

export interface WerkingsgebiedPatch {
    Area_UUID?: WerkingsgebiedPatchAreaUUID
    Description?: WerkingsgebiedPatchDescription
    Title?: WerkingsgebiedPatchTitle
}

export type WerkingsgebiedFullStaticsOwner2 = UserShort | null

export type WerkingsgebiedFullStaticsOwner1 = UserShort | null

export interface WerkingsgebiedFullStatics {
    Owner_1?: WerkingsgebiedFullStaticsOwner1
    Owner_2?: WerkingsgebiedFullStaticsOwner2
}

export type WerkingsgebiedFullStartValidity = string | null

export type WerkingsgebiedFullRelatedObjects =
    WerkingsgebiedRelatedObjects | null

export type WerkingsgebiedFullModifiedBy = UserShort | null

export type WerkingsgebiedFullEndValidity = string | null

export type WerkingsgebiedFullCreatedBy = UserShort | null

export type WerkingsgebiedFullAreaUUID = string | null

export type WerkingsgebiedFullArea = AreaBasic | null

export type WerkingsgebiedFullAdjustOn = string | null

export interface WerkingsgebiedFull {
    Adjust_On?: WerkingsgebiedFullAdjustOn
    Area?: WerkingsgebiedFullArea
    Area_UUID?: WerkingsgebiedFullAreaUUID
    Code?: string
    Created_By?: WerkingsgebiedFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: WerkingsgebiedFullEndValidity
    Modified_By?: WerkingsgebiedFullModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: WerkingsgebiedFullStatics
    Related_Objects?: WerkingsgebiedFullRelatedObjects
    Start_Validity?: WerkingsgebiedFullStartValidity
    Title?: string
    UUID?: string
}

export type WerkingsgebiedExtendedStaticsOwner2 = UserShort | null

export type WerkingsgebiedExtendedStaticsOwner1 = UserShort | null

export interface WerkingsgebiedExtendedStatics {
    Owner_1?: WerkingsgebiedExtendedStaticsOwner1
    Owner_2?: WerkingsgebiedExtendedStaticsOwner2
}

export type WerkingsgebiedExtendedStartValidity = string | null

export type WerkingsgebiedExtendedModifiedBy = UserShort | null

export type WerkingsgebiedExtendedEndValidity = string | null

export type WerkingsgebiedExtendedCreatedBy = UserShort | null

export type WerkingsgebiedExtendedAreaUUID = string | null

export type WerkingsgebiedExtendedAdjustOn = string | null

export interface WerkingsgebiedExtended {
    Adjust_On?: WerkingsgebiedExtendedAdjustOn
    Area_UUID?: WerkingsgebiedExtendedAreaUUID
    Code?: string
    Created_By?: WerkingsgebiedExtendedCreatedBy
    Created_Date?: string
    End_Validity?: WerkingsgebiedExtendedEndValidity
    Modified_By?: WerkingsgebiedExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: WerkingsgebiedExtendedStatics
    Start_Validity?: WerkingsgebiedExtendedStartValidity
    Title?: string
    UUID?: string
}

export type WerkingsgebiedBasicStartValidity = string | null

export type WerkingsgebiedBasicEndValidity = string | null

export type WerkingsgebiedBasicAreaUUID = string | null

export type WerkingsgebiedBasicAdjustOn = string | null

export interface WerkingsgebiedBasic {
    Adjust_On?: WerkingsgebiedBasicAdjustOn
    Area_UUID?: WerkingsgebiedBasicAreaUUID
    Code?: string
    Created_Date?: string
    End_Validity?: WerkingsgebiedBasicEndValidity
    Modified_Date?: string
    Object_ID?: number
    Start_Validity?: WerkingsgebiedBasicStartValidity
    Title?: string
    UUID?: string
}

export type WerkingsgebiedStartValidity = string | null

export type WerkingsgebiedID = number | null

export type WerkingsgebiedGeometryHash = string | null

export type WerkingsgebiedEndValidity = string | null

export interface Werkingsgebied {
    Created_Date: string
    End_Validity?: WerkingsgebiedEndValidity
    Geometry_Hash?: WerkingsgebiedGeometryHash
    ID?: WerkingsgebiedID
    Modified_Date: string
    Start_Validity?: WerkingsgebiedStartValidity
    Title: string
    UUID: string
}

export interface VisieAlgemeenUUID {
    Object_ID?: number
    UUID?: string
}

export type VisieAlgemeenStaticStaticsOwner2 = UserShort | null

export type VisieAlgemeenStaticStaticsOwner1 = UserShort | null

export interface VisieAlgemeenStaticStatics {
    Owner_1?: VisieAlgemeenStaticStaticsOwner1
    Owner_2?: VisieAlgemeenStaticStaticsOwner2
}

export type VisieAlgemeenStaticPostStaticsOwner2UUID = string | null

export type VisieAlgemeenStaticPostStaticsOwner1UUID = string | null

export interface VisieAlgemeenStaticPostStatics {
    Owner_1_UUID?: VisieAlgemeenStaticPostStaticsOwner1UUID
    Owner_2_UUID?: VisieAlgemeenStaticPostStaticsOwner2UUID
}

export type VisieAlgemeenPatchTitle = string | null

export type VisieAlgemeenPatchDescription = string | null

export interface VisieAlgemeenPatch {
    Description?: VisieAlgemeenPatchDescription
    Title?: VisieAlgemeenPatchTitle
}

export type VisieAlgemeenFullStaticsOwner2 = UserShort | null

export type VisieAlgemeenFullStaticsOwner1 = UserShort | null

export interface VisieAlgemeenFullStatics {
    Owner_1?: VisieAlgemeenFullStaticsOwner1
    Owner_2?: VisieAlgemeenFullStaticsOwner2
}

export type VisieAlgemeenFullStartValidity = string | null

export type VisieAlgemeenFullNextVersion = NextObjectVersion | null

export type VisieAlgemeenFullModifiedBy = UserShort | null

export type VisieAlgemeenFullEndValidity = string | null

export type VisieAlgemeenFullCreatedBy = UserShort | null

export type VisieAlgemeenFullAdjustOn = string | null

export interface VisieAlgemeenFull {
    Adjust_On?: VisieAlgemeenFullAdjustOn
    Code?: string
    Created_By?: VisieAlgemeenFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: VisieAlgemeenFullEndValidity
    Gebiedsaanwijzingen_Statics?: ObjectStatics[]
    Modified_By?: VisieAlgemeenFullModifiedBy
    Modified_Date?: string
    Next_Version?: VisieAlgemeenFullNextVersion
    Object_ID?: number
    ObjectStatics?: VisieAlgemeenFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: VisieAlgemeenFullStartValidity
    Title?: string
    UUID?: string
}

export type VisieAlgemeenExtendedStaticsOwner2 = UserShort | null

export type VisieAlgemeenExtendedStaticsOwner1 = UserShort | null

export interface VisieAlgemeenExtendedStatics {
    Owner_1?: VisieAlgemeenExtendedStaticsOwner1
    Owner_2?: VisieAlgemeenExtendedStaticsOwner2
}

export type VisieAlgemeenExtendedStartValidity = string | null

export type VisieAlgemeenExtendedModifiedBy = UserShort | null

export type VisieAlgemeenExtendedEndValidity = string | null

export type VisieAlgemeenExtendedCreatedBy = UserShort | null

export type VisieAlgemeenExtendedAdjustOn = string | null

export interface VisieAlgemeenExtended {
    Adjust_On?: VisieAlgemeenExtendedAdjustOn
    Code?: string
    Created_By?: VisieAlgemeenExtendedCreatedBy
    Created_Date?: string
    End_Validity?: VisieAlgemeenExtendedEndValidity
    Modified_By?: VisieAlgemeenExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: VisieAlgemeenExtendedStatics
    Start_Validity?: VisieAlgemeenExtendedStartValidity
    Title?: string
    UUID?: string
}

export type VisieAlgemeenBasicStartValidity = string | null

export type VisieAlgemeenBasicNextVersion = NextObjectVersion | null

export type VisieAlgemeenBasicEndValidity = string | null

export type VisieAlgemeenBasicAdjustOn = string | null

export interface VisieAlgemeenBasic {
    Adjust_On?: VisieAlgemeenBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: VisieAlgemeenBasicEndValidity
    Modified_Date?: string
    Next_Version?: VisieAlgemeenBasicNextVersion
    Object_ID?: number
    Start_Validity?: VisieAlgemeenBasicStartValidity
    Title?: string
    UUID?: string
}

export interface VerplichtProgrammaUUID {
    Object_ID?: number
    UUID?: string
}

export type VerplichtProgrammaStaticStaticsOwner2 = UserShort | null

export type VerplichtProgrammaStaticStaticsOwner1 = UserShort | null

export interface VerplichtProgrammaStaticStatics {
    Owner_1?: VerplichtProgrammaStaticStaticsOwner1
    Owner_2?: VerplichtProgrammaStaticStaticsOwner2
}

export type VerplichtProgrammaStaticPostStaticsOwner2UUID = string | null

export type VerplichtProgrammaStaticPostStaticsOwner1UUID = string | null

export interface VerplichtProgrammaStaticPostStatics {
    Owner_1_UUID?: VerplichtProgrammaStaticPostStaticsOwner1UUID
    Owner_2_UUID?: VerplichtProgrammaStaticPostStaticsOwner2UUID
}

export interface VerplichtProgrammaMinimal {
    Code?: string
    Created_Date?: string
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type VerplichtProgrammaFullStaticsOwner2 = UserShort | null

export type VerplichtProgrammaFullStaticsOwner1 = UserShort | null

export interface VerplichtProgrammaFullStatics {
    Owner_1?: VerplichtProgrammaFullStaticsOwner1
    Owner_2?: VerplichtProgrammaFullStaticsOwner2
}

export type VerplichtProgrammaFullStartValidity = string | null

export type VerplichtProgrammaFullModifiedBy = UserShort | null

export type VerplichtProgrammaFullEndValidity = string | null

export type VerplichtProgrammaFullCreatedBy = UserShort | null

export interface VerplichtProgrammaFull {
    Code?: string
    Created_By?: VerplichtProgrammaFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: VerplichtProgrammaFullEndValidity
    Maatregelen?: ReadRelationShortMaatregelMinimal[]
    Modified_By?: VerplichtProgrammaFullModifiedBy
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    ObjectStatics?: VerplichtProgrammaFullStatics
    Start_Validity?: VerplichtProgrammaFullStartValidity
    Title?: string
    UUID?: string
    WettelijkeTaken?: WettelijkeTaakMinimal[]
}

export type VerplichtProgrammaEditTitle = string | null

export type VerplichtProgrammaEditDescription = string | null

export interface VerplichtProgrammaEdit {
    Description?: VerplichtProgrammaEditDescription
    Title?: VerplichtProgrammaEditTitle
}

export type VerplichtProgrammaCreateStaticsOwner2UUID = string | null

export type VerplichtProgrammaCreateStaticsOwner1UUID = string | null

export interface VerplichtProgrammaCreateStatics {
    Owner_1_UUID?: VerplichtProgrammaCreateStaticsOwner1UUID
    Owner_2_UUID?: VerplichtProgrammaCreateStaticsOwner2UUID
}

export type VerplichtProgrammaCreateDescription = string | null

export interface VerplichtProgrammaCreate {
    Description?: VerplichtProgrammaCreateDescription
    ObjectStatics?: VerplichtProgrammaCreateStatics
    Title?: string
}

export interface VerplichtProgrammaBasic {
    Code?: string
    Created_Date?: string
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type ValidationErrorLocItem = string | number

export type ValidationErrorCtx = { [key: string]: unknown }

export interface ValidationError {
    ctx?: ValidationErrorCtx
    input?: unknown
    loc: ValidationErrorLocItem[]
    msg: string
    type: string
}

export type ValidateModuleSeverity =
    (typeof ValidateModuleSeverity)[keyof typeof ValidateModuleSeverity]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidateModuleSeverity = {
    info: 'info',
    warning: 'warning',
    error: 'error',
} as const

export interface ValidateModuleObject {
    code: string
    object_id: number
    object_type: string
    title: string
}

export interface ValidateModuleError {
    messages: string[]
    object: ValidateModuleObject
    rule: string
    severity?: ValidateModuleSeverity
}

export interface ValidateModuleResult {
    errors: ValidateModuleError[]
    readonly status: string
}

export type ValidSearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModel =

        | AmbitieBasic
        | BeleidsdoelBasic
        | BeleidskeuzeBasic
        | BeleidsregelBasic
        | DocumentBasic
        | GebiedsprogrammaBasic
        | MaatregelBasic
        | NationaalBelangBasic
        | GebiedengroepBasic
        | GebiedBasic
        | GebiedsaanwijzingBasic
        | ProgrammaAlgemeenBasic
        | VerplichtProgrammaBasic
        | VisieAlgemeenBasic
        | WerkingsgebiedBasic
        | WettelijkeTaakBasic

export interface ValidSearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic {
    Description: string
    Model: ValidSearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModel
    Object_Type: string
    Score: number
}

export interface UserShort {
    UUID: string
}

export interface UserLoginDetail {
    Gebruikersnaam: string
    Rol: string
    UUID: string
}

export interface UserCreateResponse {
    Email: string
    Password: string
    Rol: string
    UUID: string
}

export interface UserCreate {
    Email: string
    /** @minLength 3 */
    Gebruikersnaam: string
    Rol: string
}

export interface User {
    Email: string
    Gebruikersnaam: string
    IsActive: boolean
    Rol: string
    Status: string
    UUID: string
}

export interface UploadPackageReportResponse {
    Duplicate_Count: number
    Status: ReportStatusType
}

export interface UploadFileResponse {
    UUID: string
}

export interface UploadAttachmentResponse {
    ID: number
}

export interface UnifiedPackage {
    Created_Date: string
    Delivery_ID: string
    Document_Type: string
    Environment_UUID: string
    Modified_Date: string
    Module_ID: number
    Module_Title: string
    Package_Type: string
    Publication_Type: string
    Report_Status: string
    UUID: string
}

export interface Thema {
    bron: string
    definitie: string
    deprecated: boolean
    domein: string
    label: string
    term: string
    toelichting: string
    uri: string
}

export type TemplateEditTitle = string | null

export type TemplateEditTextTemplate = string | null

export type TemplateEditObjectTypes = string[] | null

export type TemplateEditObjectTemplatesAnyOf = { [key: string]: string }

export type TemplateEditObjectTemplates =
    TemplateEditObjectTemplatesAnyOf | null

export type TemplateEditObjectFieldMapAnyOf = { [key: string]: string[] }

export type TemplateEditObjectFieldMap = TemplateEditObjectFieldMapAnyOf | null

export type TemplateEditIsActive = boolean | null

/**
 * @deprecated
 */
export type TemplateEditFieldMap = string[] | null

export type TemplateEditDocumentType = DocumentType | null

export type TemplateEditDescription = string | null

export interface TemplateEdit {
    Description?: TemplateEditDescription
    Document_Type?: TemplateEditDocumentType
    /** @deprecated */
    Field_Map?: TemplateEditFieldMap
    Is_Active?: TemplateEditIsActive
    Object_Field_Map?: TemplateEditObjectFieldMap
    Object_Templates?: TemplateEditObjectTemplates
    Object_Types?: TemplateEditObjectTypes
    Text_Template?: TemplateEditTextTemplate
    Title?: TemplateEditTitle
}

export interface TemplateCreatedResponse {
    UUID: string
}

export type TemplateCreateObjectTemplates = { [key: string]: string }

export type TemplateCreateObjectFieldMap = { [key: string]: string[] }

export interface TemplateCreate {
    Description: string
    Document_Type: DocumentType
    Object_Field_Map: TemplateCreateObjectFieldMap
    Object_Templates: TemplateCreateObjectTemplates
    Object_Types: string[]
    Text_Template: string
    /** @minLength 3 */
    Title: string
}

export interface StorageFileBasic {
    Checksum: string
    Content_Type: string
    Created_By_UUID: string
    Created_Date: string
    Filename: string
    Size: number
    UUID: string
}

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortOrder = {
    ASC: 'ASC',
    DESC: 'DESC',
} as const

export type SearchRequestDataWithLikeObjectTypes = string[] | null

export interface SearchRequestDataWithLike {
    Like?: boolean
    Object_Types?: SearchRequestDataWithLikeObjectTypes
}

export type SearchRequestDataObjectTypes = string[] | null

export interface SearchRequestData {
    Object_Types?: SearchRequestDataObjectTypes
}

export type SearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModuleID =
    number | null

export type SearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModel =

        | AmbitieBasic
        | BeleidsdoelBasic
        | BeleidskeuzeBasic
        | BeleidsregelBasic
        | DocumentBasic
        | GebiedsprogrammaBasic
        | MaatregelBasic
        | NationaalBelangBasic
        | GebiedengroepBasic
        | GebiedBasic
        | GebiedsaanwijzingBasic
        | ProgrammaAlgemeenBasic
        | VerplichtProgrammaBasic
        | VisieAlgemeenBasic
        | WerkingsgebiedBasic
        | WettelijkeTaakBasic

export interface SearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic {
    Description: string
    Model: SearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModel
    Module_ID?: SearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModuleID
    Object_Type: string
    Score: number
}

export type RootModelListObjectCount = ObjectCount[]

export interface ResponseOK {
    message?: string
}

export interface ResetPasswordResponse {
    NewPassword: string
    UUID: string
}

export type RequestAcknowledgedRelationExplanation = string | null

export interface RequestAcknowledgedRelation {
    Explanation?: RequestAcknowledgedRelationExplanation
    Object_ID: number
    Object_Type: string
}

export type ReportStatusType =
    (typeof ReportStatusType)[keyof typeof ReportStatusType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportStatusType = {
    not_applicable: 'not_applicable',
    pending: 'pending',
    valid: 'valid',
    failed: 'failed',
    aborted: 'aborted',
} as const

export interface ReadRelationShort {
    Description?: string
    Object_ID: number
    Object_Type: string
}

export interface ReadRelationShortWettelijkeTaakMinimal {
    Object?: WettelijkeTaakMinimal
    Relation?: ReadRelationShort
}

export interface ReadRelationShortNationaalBelangMinimal {
    Object?: NationaalBelangMinimal
    Relation?: ReadRelationShort
}

export interface ReadRelationShortMaatregelMinimal {
    Object?: MaatregelMinimal
    Relation?: ReadRelationShort
}

export interface ReadRelationShortGebiedsprogrammaMinimal {
    Object?: GebiedsprogrammaMinimal
    Relation?: ReadRelationShort
}

export interface ReadRelationShortBeleidsregelMinimal {
    Object?: BeleidsregelMinimal
    Relation?: ReadRelationShort
}

export interface ReadRelationShortBeleidskeuzeMinimal {
    Object?: BeleidskeuzeMinimal
    Relation?: ReadRelationShort
}

export interface ReadRelationShortBeleidsdoelMinimal {
    Object?: BeleidsdoelMinimal
    Relation?: ReadRelationShort
}

export interface ReadRelationShortAmbitieMinimal {
    Object?: AmbitieMinimal
    Relation?: ReadRelationShort
}

export interface ReadRelation {
    Description?: string
    Object_ID: number
    Object_Type: string
    Title?: string
}

export type PublicationVersionStatus =
    (typeof PublicationVersionStatus)[keyof typeof PublicationVersionStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicationVersionStatus = {
    not_applicable: 'not_applicable',
    active: 'active',
    validation: 'validation',
    validation_failed: 'validation_failed',
    publication: 'publication',
    publication_failed: 'publication_failed',
    publication_aborted: 'publication_aborted',
    announcement: 'announcement',
    completed: 'completed',
} as const

export type PublicationVersionShortProcedural = Procedural | null

export type PublicationVersionShortEffectiveDate = string | null

export type PublicationVersionShortBillMetadata = { [key: string]: unknown }

export type PublicationVersionShortAnnouncementDate = string | null

export interface PublicationVersionShort {
    Act_Packages: PublicationPackageShort[]
    Announcement_Date?: PublicationVersionShortAnnouncementDate
    Bill_Metadata: PublicationVersionShortBillMetadata
    Created_Date: string
    Effective_Date?: PublicationVersionShortEffectiveDate
    Is_Locked: boolean
    Modified_Date: string
    Module_Status: ModuleStatus
    Procedural?: PublicationVersionShortProcedural
    Publication_UUID: string
    Status: PublicationVersionStatus
    UUID: string
}

export interface PublicationVersionEditResponse {
    Errors: ErrorDetails[]
    Is_Valid: boolean
}

export type PublicationVersionEditProcedural = Procedural | null

export type PublicationVersionEditModuleStatusID = number | null

export type PublicationVersionEditEffectiveDate = string | null

export type PublicationVersionEditBillMetadata = BillMetadata | null

export type PublicationVersionEditBillCompact = BillCompact | null

export type PublicationVersionEditAnnouncementDate = string | null

export interface PublicationVersionEdit {
    Announcement_Date?: PublicationVersionEditAnnouncementDate
    Bill_Compact?: PublicationVersionEditBillCompact
    Bill_Metadata?: PublicationVersionEditBillMetadata
    Effective_Date?: PublicationVersionEditEffectiveDate
    Module_Status_ID?: PublicationVersionEditModuleStatusID
    Procedural?: PublicationVersionEditProcedural
}

export interface PublicationVersionCreatedResponse {
    UUID: string
}

export interface PublicationVersionCreate {
    Module_Status_ID: number
}

export type PublicationVersionProcedural = { [key: string]: unknown }

export type PublicationVersionEffectiveDate = string | null

export type PublicationVersionBillMetadata = { [key: string]: unknown }

export type PublicationVersionBillCompact = { [key: string]: unknown }

export type PublicationVersionAnnouncementDate = string | null

export interface PublicationVersion {
    Announcement_Date?: PublicationVersionAnnouncementDate
    Attachments: AttachmentShort[]
    Bill_Compact: PublicationVersionBillCompact
    Bill_Metadata: PublicationVersionBillMetadata
    Created_Date: string
    Effective_Date?: PublicationVersionEffectiveDate
    Errors?: ErrorDetails[]
    Is_Locked: boolean
    Modified_Date: string
    Module_Status: ModuleStatus
    Procedural: PublicationVersionProcedural
    Publication: PublicationShort
    Status: PublicationVersionStatus
    UUID: string
}

export type PublicationType =
    (typeof PublicationType)[keyof typeof PublicationType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicationType = {
    act: 'act',
    announcement: 'announcement',
} as const

export interface PublicationTemplate {
    Created_Date: string
    Description: string
    Document_Type: string
    Is_Active: boolean
    Modified_Date: string
    Object_Field_Map?: unknown
    Object_Templates?: unknown
    Object_Types?: unknown
    Text_Template: string
    Title: string
    UUID: string
}

export type PublicationShortTemplateUUID = string | null

export type PublicationShortEnvironmentUUID = string | null

export type PublicationShortActUUID = string | null

export interface PublicationShort {
    Act_UUID?: PublicationShortActUUID
    Created_Date: string
    Document_Type: string
    Environment_UUID?: PublicationShortEnvironmentUUID
    Is_Locked: boolean
    Modified_Date: string
    Module_ID: number
    Procedure_Type: string
    Template_UUID?: PublicationShortTemplateUUID
    UUID: string
}

export interface PublicationPackageShort {
    Created_By_UUID: string
    Created_Date: string
    Delivery_ID: string
    Modified_By_UUID: string
    Modified_Date: string
    Package_Type: string
    Report_Status: string
    UUID: string
}

export interface PublicationPackagePdf {
    Mutation?: MutationStrategy
}

export interface PublicationPackageCreatedResponse {
    Package_UUID: string
    Zip_UUID: string
}

export interface PublicationPackageCreate {
    Package_Type: PackageType
}

export interface PublicationPackage {
    Created_By_UUID: string
    Created_Date: string
    Delivery_ID: string
    Modified_By_UUID: string
    Modified_Date: string
    Package_Type: string
    Report_Status: string
    UUID: string
    Zip: PackageZipShort
}

export interface PublicationEnvironment {
    Authority_ID: string
    Can_Publicate: boolean
    Can_Validate: boolean
    Created_Date: string
    Description: string
    Frbr_Country: string
    Frbr_Language: string
    Governing_Body_Type: string
    Has_State: boolean
    Is_Active: boolean
    Is_Locked: boolean
    Modified_Date: string
    Province_ID: string
    Submitter_ID: string
    Title: string
    UUID: string
}

export type PublicationEditTemplateUUID = string | null

export interface PublicationEdit {
    Template_UUID?: PublicationEditTemplateUUID
}

export interface PublicationCreatedResponse {
    UUID: string
}

export interface PublicationCreate {
    Act_UUID: string
    Document_Type: DocumentType
    Environment_UUID: string
    Module_ID: number
    Procedure_Type: ProcedureType
    Template_UUID: string
}

export type PublicationAnnouncementShortMetadata = { [key: string]: unknown }

export type PublicationAnnouncementShortAnnouncementDate = string | null

export interface PublicationAnnouncementShort {
    Announcement_Date?: PublicationAnnouncementShortAnnouncementDate
    Created_Date: string
    Is_Locked: boolean
    Metadata: PublicationAnnouncementShortMetadata
    Modified_Date: string
    UUID: string
}

export interface PublicationAnnouncementPackageReportShort {
    Announcement_Package_UUID: string
    Created_Date: string
    Filename: string
    Main_Outcome: string
    Report_Status: string
    UUID: string
}

export interface PublicationAnnouncementPackageReport {
    Announcement_Package_UUID: string
    Created_Date: string
    Filename: string
    Main_Outcome: string
    Report_Status: string
    Source_Document: string
    Sub_Delivery_ID: string
    Sub_Outcome: string
    Sub_Progress: string
    UUID: string
}

export type PublicationAnnouncementPackageDetailResponseUsedEnvironmentStateUUID =
    string | null

export type PublicationAnnouncementPackageDetailResponseDocVersionUUID =
    | string
    | null

export type PublicationAnnouncementPackageDetailResponseCreatedEnvironmentStateUUID =
    string | null

export interface PublicationAnnouncementPackageDetailResponse {
    Announcement_UUID: string
    Created_By_UUID: string
    Created_Date: string
    Created_Environment_State_UUID: PublicationAnnouncementPackageDetailResponseCreatedEnvironmentStateUUID
    Delivery_ID: string
    Doc_Version_UUID: PublicationAnnouncementPackageDetailResponseDocVersionUUID
    Document_Type: string
    Environment_Title: string
    Environment_UUID: string
    Modified_By_UUID: string
    Modified_Date: string
    Module_ID: number
    Module_Status_ID: number
    Module_Status_Status: string
    Module_Title: string
    Package_Type: string
    Report_Status: string
    Used_Environment_State_UUID: PublicationAnnouncementPackageDetailResponseUsedEnvironmentStateUUID
    UUID: string
    Zip: PackageZipShort
}

export interface PublicationAnnouncementPackageCreatedResponse {
    Package_UUID: string
    Zip_UUID: string
}

export interface PublicationAnnouncementPackageCreate {
    Package_Type: PackageType
}

export type PublicationAnnouncementEditProcedural =
    AnnouncementProcedural | null

export type PublicationAnnouncementEditMetadata = AnnouncementMetadata | null

export type PublicationAnnouncementEditContent = AnnouncementContent | null

export type PublicationAnnouncementEditAnnouncementDate = string | null

export interface PublicationAnnouncementEdit {
    Announcement_Date?: PublicationAnnouncementEditAnnouncementDate
    Content?: PublicationAnnouncementEditContent
    Metadata?: PublicationAnnouncementEditMetadata
    Procedural?: PublicationAnnouncementEditProcedural
}

export type PublicationAnnouncementProcedural = { [key: string]: unknown }

export type PublicationAnnouncementMetadata = { [key: string]: unknown }

export type PublicationAnnouncementContent = { [key: string]: unknown }

export type PublicationAnnouncementAnnouncementDate = string | null

export interface PublicationAnnouncement {
    Act_Package: PublicationPackageShort
    Announcement_Date?: PublicationAnnouncementAnnouncementDate
    Content: PublicationAnnouncementContent
    Created_Date: string
    Is_Locked: boolean
    Metadata: PublicationAnnouncementMetadata
    Modified_Date: string
    Procedural: PublicationAnnouncementProcedural
    Publication: PublicationShort
    UUID: string
}

export interface PublicationActShort {
    Created_Date: string
    Document_Type: string
    Environment_UUID: string
    Is_Active: boolean
    Modified_Date: string
    Title: string
    UUID: string
    Work_Country: string
    Work_Date: string
    Work_Other: string
    Work_Province_ID: string
}

export interface PublicationActPackageReportShort {
    Act_Package_UUID: string
    Created_Date: string
    Filename: string
    Main_Outcome: string
    Report_Status: string
    UUID: string
}

export interface PublicationActPackageReport {
    Act_Package_UUID: string
    Created_Date: string
    Filename: string
    Main_Outcome: string
    Report_Status: string
    Source_Document: string
    Sub_Delivery_ID: string
    Sub_Outcome: string
    Sub_Progress: string
    UUID: string
}

export type PublicationActPackageDetailResponseUsedEnvironmentStateUUID =
    | string
    | null

export type PublicationActPackageDetailResponseCreatedEnvironmentStateUUID =
    | string
    | null

export type PublicationActPackageDetailResponseBillVersionUUID = string | null

export type PublicationActPackageDetailResponseActVersionUUID = string | null

export interface PublicationActPackageDetailResponse {
    Act_Version_UUID: PublicationActPackageDetailResponseActVersionUUID
    Bill_Version_UUID: PublicationActPackageDetailResponseBillVersionUUID
    Created_By_UUID: string
    Created_Date: string
    Created_Environment_State_UUID: PublicationActPackageDetailResponseCreatedEnvironmentStateUUID
    Delivery_ID: string
    Document_Type: string
    Environment_Title: string
    Environment_UUID: string
    Modified_By_UUID: string
    Modified_Date: string
    Module_ID: number
    Module_Status_ID: number
    Module_Status_Status: string
    Module_Title: string
    Package_Type: string
    Publication_Version_UUID: string
    Report_Status: string
    Used_Environment_State_UUID: PublicationActPackageDetailResponseUsedEnvironmentStateUUID
    UUID: string
    Zip: PackageZipShort
}

export type PublicationActMetadata = { [key: string]: unknown }

export interface PublicationAct {
    Created_Date: string
    Document_Type: string
    Environment: PublicationEnvironment
    Is_Active: boolean
    Metadata: PublicationActMetadata
    Modified_Date: string
    Title: string
    UUID: string
    Work_Country: string
    Work_Date: string
    Work_Other: string
    Work_Province_ID: string
}

export interface PublicationAOJ {
    Administrative_Borders_Date: string
    Administrative_Borders_Domain: string
    Administrative_Borders_ID: string
    Created_Date: string
    UUID: string
}

export type PublicationTemplateUUID = string | null

export type PublicationEnvironmentUUID = string | null

export type PublicationActUUID = string | null

export interface Publication {
    Act_UUID?: PublicationActUUID
    Created_Date: string
    Document_Type: string
    Environment_UUID?: PublicationEnvironmentUUID
    Is_Locked: boolean
    Modified_Date: string
    Module_ID: number
    Procedure_Type: string
    Template_UUID?: PublicationTemplateUUID
    UUID: string
}

export type PublicModuleStatusCode =
    (typeof PublicModuleStatusCode)[keyof typeof PublicModuleStatusCode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicModuleStatusCode = {
    Ter_Inzage: 'Ter Inzage',
    Ontwerp_GS: 'Ontwerp GS',
    Definitief_ontwerp_GS: 'Definitief ontwerp GS',
    Ontwerp_PS: 'Ontwerp PS',
    Definitief_ontwerp_PS: 'Definitief ontwerp PS',
    Vastgesteld: 'Vastgesteld',
} as const

export type PublicModuleShortStatus = ModuleStatus | null

export interface PublicModuleShort {
    Description: string
    Module_ID: number
    Status?: PublicModuleShortStatus
    Title: string
}

export type PublicModuleObjectShortModuleObjectContext =
    PublicModuleObjectContextShort | null

export interface PublicModuleObjectShort {
    Code: string
    Description: string
    Modified_Date: string
    Module_ID: number
    ModuleObjectContext?: PublicModuleObjectShortModuleObjectContext
    Object_ID: number
    Object_Type: string
    Title: string
    UUID: string
}

export interface PublicModuleOverview {
    Module: PublicModuleShort
    Objects: PublicModuleObjectShort[]
}

export interface PublicModuleObjectRevision {
    Action: ModuleObjectActionFull
    Module_ID: number
    Module_Object_Code: string
    Module_Object_Status: PublicModuleStatusCode
    Module_Object_UUID: string
    Module_Status: ModuleStatusCode
    Module_Title: string
}

export type PublicModuleObjectContextShortOriginalAdjustOn = string | null

export interface PublicModuleObjectContextShort {
    Action: string
    Original_Adjust_On?: PublicModuleObjectContextShortOriginalAdjustOn
}

export interface ProgrammaAlgemeenUUID {
    Object_ID?: number
    UUID?: string
}

export type ProgrammaAlgemeenStaticStaticsOwner2 = UserShort | null

export type ProgrammaAlgemeenStaticStaticsOwner1 = UserShort | null

export interface ProgrammaAlgemeenStaticStatics {
    Owner_1?: ProgrammaAlgemeenStaticStaticsOwner1
    Owner_2?: ProgrammaAlgemeenStaticStaticsOwner2
}

export type ProgrammaAlgemeenStaticPostStaticsOwner2UUID = string | null

export type ProgrammaAlgemeenStaticPostStaticsOwner1UUID = string | null

export interface ProgrammaAlgemeenStaticPostStatics {
    Owner_1_UUID?: ProgrammaAlgemeenStaticPostStaticsOwner1UUID
    Owner_2_UUID?: ProgrammaAlgemeenStaticPostStaticsOwner2UUID
}

export type ProgrammaAlgemeenPatchTitle = string | null

export type ProgrammaAlgemeenPatchDescription = string | null

export interface ProgrammaAlgemeenPatch {
    Description?: ProgrammaAlgemeenPatchDescription
    Title?: ProgrammaAlgemeenPatchTitle
}

export type ProgrammaAlgemeenFullStaticsOwner2 = UserShort | null

export type ProgrammaAlgemeenFullStaticsOwner1 = UserShort | null

export interface ProgrammaAlgemeenFullStatics {
    Owner_1?: ProgrammaAlgemeenFullStaticsOwner1
    Owner_2?: ProgrammaAlgemeenFullStaticsOwner2
}

export type ProgrammaAlgemeenFullStartValidity = string | null

export type ProgrammaAlgemeenFullNextVersion = NextObjectVersion | null

export type ProgrammaAlgemeenFullModifiedBy = UserShort | null

export type ProgrammaAlgemeenFullEndValidity = string | null

export type ProgrammaAlgemeenFullCreatedBy = UserShort | null

export type ProgrammaAlgemeenFullAdjustOn = string | null

export interface ProgrammaAlgemeenFull {
    Adjust_On?: ProgrammaAlgemeenFullAdjustOn
    Code?: string
    Created_By?: ProgrammaAlgemeenFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: ProgrammaAlgemeenFullEndValidity
    Gebiedsaanwijzingen_Statics?: ObjectStatics[]
    Modified_By?: ProgrammaAlgemeenFullModifiedBy
    Modified_Date?: string
    Next_Version?: ProgrammaAlgemeenFullNextVersion
    Object_ID?: number
    ObjectStatics?: ProgrammaAlgemeenFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: ProgrammaAlgemeenFullStartValidity
    Title?: string
    UUID?: string
}

export type ProgrammaAlgemeenExtendedStaticsOwner2 = UserShort | null

export type ProgrammaAlgemeenExtendedStaticsOwner1 = UserShort | null

export interface ProgrammaAlgemeenExtendedStatics {
    Owner_1?: ProgrammaAlgemeenExtendedStaticsOwner1
    Owner_2?: ProgrammaAlgemeenExtendedStaticsOwner2
}

export type ProgrammaAlgemeenExtendedStartValidity = string | null

export type ProgrammaAlgemeenExtendedModifiedBy = UserShort | null

export type ProgrammaAlgemeenExtendedEndValidity = string | null

export type ProgrammaAlgemeenExtendedCreatedBy = UserShort | null

export type ProgrammaAlgemeenExtendedAdjustOn = string | null

export interface ProgrammaAlgemeenExtended {
    Adjust_On?: ProgrammaAlgemeenExtendedAdjustOn
    Code?: string
    Created_By?: ProgrammaAlgemeenExtendedCreatedBy
    Created_Date?: string
    End_Validity?: ProgrammaAlgemeenExtendedEndValidity
    Modified_By?: ProgrammaAlgemeenExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: ProgrammaAlgemeenExtendedStatics
    Start_Validity?: ProgrammaAlgemeenExtendedStartValidity
    Title?: string
    UUID?: string
}

export type ProgrammaAlgemeenBasicStartValidity = string | null

export type ProgrammaAlgemeenBasicNextVersion = NextObjectVersion | null

export type ProgrammaAlgemeenBasicEndValidity = string | null

export type ProgrammaAlgemeenBasicAdjustOn = string | null

export interface ProgrammaAlgemeenBasic {
    Adjust_On?: ProgrammaAlgemeenBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: ProgrammaAlgemeenBasicEndValidity
    Modified_Date?: string
    Next_Version?: ProgrammaAlgemeenBasicNextVersion
    Object_ID?: number
    Start_Validity?: ProgrammaAlgemeenBasicStartValidity
    Title?: string
    UUID?: string
}

export type ProcedureType = (typeof ProcedureType)[keyof typeof ProcedureType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcedureType = {
    draft: 'draft',
    final: 'final',
} as const

export type ProceduralSignedDate = string | null

export type ProceduralProceduralAnnouncementDate = string | null

export type ProceduralEnactmentDate = string | null

export interface Procedural {
    Enactment_Date?: ProceduralEnactmentDate
    Procedural_Announcement_Date?: ProceduralProceduralAnnouncementDate
    Signed_Date?: ProceduralSignedDate
}

export interface PatchResponse {
    UUID: string
}

export interface PagedResponseWettelijkeTaakBasic {
    limit?: number
    offset?: number
    results: WettelijkeTaakBasic[]
    total: number
}

export interface PagedResponseWerkingsgebied {
    limit?: number
    offset?: number
    results: Werkingsgebied[]
    total: number
}

export interface PagedResponseWerkingsgebiedExtended {
    limit?: number
    offset?: number
    results: WerkingsgebiedExtended[]
    total: number
}

export interface PagedResponseWerkingsgebiedBasic {
    limit?: number
    offset?: number
    results: WerkingsgebiedBasic[]
    total: number
}

export interface PagedResponseVisieAlgemeenExtended {
    limit?: number
    offset?: number
    results: VisieAlgemeenExtended[]
    total: number
}

export interface PagedResponseVisieAlgemeenBasic {
    limit?: number
    offset?: number
    results: VisieAlgemeenBasic[]
    total: number
}

export interface PagedResponseVerplichtProgrammaBasic {
    limit?: number
    offset?: number
    results: VerplichtProgrammaBasic[]
    total: number
}

export interface PagedResponseValidSearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic {
    limit?: number
    offset?: number
    results: ValidSearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic[]
    total: number
}

export interface PagedResponseUser {
    limit?: number
    offset?: number
    results: User[]
    total: number
}

export interface PagedResponseUnifiedPackage {
    limit?: number
    offset?: number
    results: UnifiedPackage[]
    total: number
}

export interface PagedResponseStorageFileBasic {
    limit?: number
    offset?: number
    results: StorageFileBasic[]
    total: number
}

export interface PagedResponseSearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic {
    limit?: number
    offset?: number
    results: SearchObjectUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic[]
    total: number
}

export interface PagedResponsePublication {
    limit?: number
    offset?: number
    results: Publication[]
    total: number
}

export interface PagedResponsePublicationVersionShort {
    limit?: number
    offset?: number
    results: PublicationVersionShort[]
    total: number
}

export interface PagedResponsePublicationTemplate {
    limit?: number
    offset?: number
    results: PublicationTemplate[]
    total: number
}

export interface PagedResponsePublicationPackage {
    limit?: number
    offset?: number
    results: PublicationPackage[]
    total: number
}

export interface PagedResponsePublicationEnvironment {
    limit?: number
    offset?: number
    results: PublicationEnvironment[]
    total: number
}

export interface PagedResponsePublicationAnnouncementShort {
    limit?: number
    offset?: number
    results: PublicationAnnouncementShort[]
    total: number
}

export interface PagedResponsePublicationAnnouncementPackageReportShort {
    limit?: number
    offset?: number
    results: PublicationAnnouncementPackageReportShort[]
    total: number
}

export interface PagedResponsePublicationActShort {
    limit?: number
    offset?: number
    results: PublicationActShort[]
    total: number
}

export interface PagedResponsePublicationActPackageReportShort {
    limit?: number
    offset?: number
    results: PublicationActPackageReportShort[]
    total: number
}

export interface PagedResponsePublicationAOJ {
    limit?: number
    offset?: number
    results: PublicationAOJ[]
    total: number
}

export interface PagedResponsePublicModuleShort {
    limit?: number
    offset?: number
    results: PublicModuleShort[]
    total: number
}

export interface PagedResponseProgrammaAlgemeenExtended {
    limit?: number
    offset?: number
    results: ProgrammaAlgemeenExtended[]
    total: number
}

export interface PagedResponseProgrammaAlgemeenBasic {
    limit?: number
    offset?: number
    results: ProgrammaAlgemeenBasic[]
    total: number
}

export interface PagedResponseObjectListAllLatestResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic {
    limit?: number
    offset?: number
    results: ObjectListAllLatestResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic[]
    total: number
}

export interface PagedResponseNationaalBelangBasic {
    limit?: number
    offset?: number
    results: NationaalBelangBasic[]
    total: number
}

export interface PagedResponseModule {
    limit?: number
    offset?: number
    results: Module[]
    total: number
}

export interface PagedResponseModuleObjectsResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic {
    limit?: number
    offset?: number
    results: ModuleObjectsResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic[]
    total: number
}

export interface PagedResponseMaatregelExtended {
    limit?: number
    offset?: number
    results: MaatregelExtended[]
    total: number
}

export interface PagedResponseMaatregelBasic {
    limit?: number
    offset?: number
    results: MaatregelBasic[]
    total: number
}

export interface PagedResponseInputGeoWerkingsgebied {
    limit?: number
    offset?: number
    results: InputGeoWerkingsgebied[]
    total: number
}

export interface PagedResponseGebiedsprogrammaExtended {
    limit?: number
    offset?: number
    results: GebiedsprogrammaExtended[]
    total: number
}

export interface PagedResponseGebiedsprogrammaBasic {
    limit?: number
    offset?: number
    results: GebiedsprogrammaBasic[]
    total: number
}

export interface PagedResponseGebiedsaanwijzingExtended {
    limit?: number
    offset?: number
    results: GebiedsaanwijzingExtended[]
    total: number
}

export interface PagedResponseGebiedsaanwijzingBasic {
    limit?: number
    offset?: number
    results: GebiedsaanwijzingBasic[]
    total: number
}

export interface PagedResponseGebiedengroepExtended {
    limit?: number
    offset?: number
    results: GebiedengroepExtended[]
    total: number
}

export interface PagedResponseGebiedengroepBasic {
    limit?: number
    offset?: number
    results: GebiedengroepBasic[]
    total: number
}

export interface PagedResponseGebiedExtended {
    limit?: number
    offset?: number
    results: GebiedExtended[]
    total: number
}

export interface PagedResponseGebiedBasic {
    limit?: number
    offset?: number
    results: GebiedBasic[]
    total: number
}

export interface PagedResponseDocumentExtended {
    limit?: number
    offset?: number
    results: DocumentExtended[]
    total: number
}

export interface PagedResponseDocumentBasic {
    limit?: number
    offset?: number
    results: DocumentBasic[]
    total: number
}

export interface PagedResponseBeleidsregelExtended {
    limit?: number
    offset?: number
    results: BeleidsregelExtended[]
    total: number
}

export interface PagedResponseBeleidsregelBasic {
    limit?: number
    offset?: number
    results: BeleidsregelBasic[]
    total: number
}

export interface PagedResponseBeleidskeuzeExtended {
    limit?: number
    offset?: number
    results: BeleidskeuzeExtended[]
    total: number
}

export interface PagedResponseBeleidskeuzeBasic {
    limit?: number
    offset?: number
    results: BeleidskeuzeBasic[]
    total: number
}

export interface PagedResponseBeleidsdoelExtended {
    limit?: number
    offset?: number
    results: BeleidsdoelExtended[]
    total: number
}

export interface PagedResponseBeleidsdoelBasic {
    limit?: number
    offset?: number
    results: BeleidsdoelBasic[]
    total: number
}

export interface PagedResponseAmbitieExtended {
    limit?: number
    offset?: number
    results: AmbitieExtended[]
    total: number
}

export interface PagedResponseAmbitieBasic {
    limit?: number
    offset?: number
    results: AmbitieBasic[]
    total: number
}

export type PackageZipShortLatestDownloadDate = string | null

export type PackageZipShortLatestDownloadByUUID = string | null

export interface PackageZipShort {
    Filename: string
    Latest_Download_By_UUID?: PackageZipShortLatestDownloadByUUID
    Latest_Download_Date?: PackageZipShortLatestDownloadDate
    UUID: string
}

export type PackageType = (typeof PackageType)[keyof typeof PackageType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PackageType = {
    validation: 'validation',
    publication: 'publication',
} as const

export type OwnerType = (typeof OwnerType)[keyof typeof OwnerType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerType = {
    All: 'All',
    Mine: 'Mine',
    Others: 'Others',
} as const

export interface ObjectStatics {
    Cached_Title: string
    Code: string
    Object_ID: number
    Object_Type: string
}

export type ObjectStaticShortPortfolioHolder2UUID = string | null

export type ObjectStaticShortPortfolioHolder1UUID = string | null

export type ObjectStaticShortOwner2UUID = string | null

export type ObjectStaticShortOwner1UUID = string | null

export type ObjectStaticShortClient1UUID = string | null

export interface ObjectStaticShort {
    Client_1_UUID?: ObjectStaticShortClient1UUID
    Owner_1_UUID?: ObjectStaticShortOwner1UUID
    Owner_2_UUID?: ObjectStaticShortOwner2UUID
    Portfolio_Holder_1_UUID?: ObjectStaticShortPortfolioHolder1UUID
    Portfolio_Holder_2_UUID?: ObjectStaticShortPortfolioHolder2UUID
}

export type ObjectListAllLatestResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModel =

        | AmbitieBasic
        | BeleidsdoelBasic
        | BeleidskeuzeBasic
        | BeleidsregelBasic
        | DocumentBasic
        | GebiedsprogrammaBasic
        | MaatregelBasic
        | NationaalBelangBasic
        | GebiedengroepBasic
        | GebiedBasic
        | GebiedsaanwijzingBasic
        | ProgrammaAlgemeenBasic
        | VerplichtProgrammaBasic
        | VisieAlgemeenBasic
        | WerkingsgebiedBasic
        | WettelijkeTaakBasic

export interface ObjectListAllLatestResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic {
    Model: ObjectListAllLatestResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModel
    Object_Type: string
    ObjectStatics: ObjectStaticShort
}

export interface ObjectCount {
    count: number
    object_type: string
}

export type NextObjectVersionEndValidity = string | null

export interface NextObjectVersion {
    Created_Date: string
    End_Validity?: NextObjectVersionEndValidity
    Modified_Date: string
    Previous_UUID: string
    Start_Validity: string
    Title: string
    UUID: string
}

export interface NewObjectStaticResponse {
    Code: string
    Object_ID: number
    Object_Type: string
}

export interface NationaalBelangUUID {
    Object_ID?: number
    UUID?: string
}

export type NationaalBelangStaticStaticsOwner2 = UserShort | null

export type NationaalBelangStaticStaticsOwner1 = UserShort | null

export interface NationaalBelangStaticStatics {
    Owner_1?: NationaalBelangStaticStaticsOwner1
    Owner_2?: NationaalBelangStaticStaticsOwner2
}

export type NationaalBelangStaticPostStaticsOwner2UUID = string | null

export type NationaalBelangStaticPostStaticsOwner1UUID = string | null

export interface NationaalBelangStaticPostStatics {
    Owner_1_UUID?: NationaalBelangStaticPostStaticsOwner1UUID
    Owner_2_UUID?: NationaalBelangStaticPostStaticsOwner2UUID
}

export interface NationaalBelangMinimal {
    Code?: string
    Created_Date?: string
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
    Weblink?: string
}

export type NationaalBelangFullStaticsOwner2 = UserShort | null

export type NationaalBelangFullStaticsOwner1 = UserShort | null

export interface NationaalBelangFullStatics {
    Owner_1?: NationaalBelangFullStaticsOwner1
    Owner_2?: NationaalBelangFullStaticsOwner2
}

export type NationaalBelangFullStartValidity = string | null

export type NationaalBelangFullModifiedBy = UserShort | null

export type NationaalBelangFullEndValidity = string | null

export type NationaalBelangFullCreatedBy = UserShort | null

export interface NationaalBelangFull {
    Beleidskeuzes?: BeleidskeuzeMinimal[]
    Code?: string
    Created_By?: NationaalBelangFullCreatedBy
    Created_Date?: string
    End_Validity?: NationaalBelangFullEndValidity
    Modified_By?: NationaalBelangFullModifiedBy
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    ObjectStatics?: NationaalBelangFullStatics
    Start_Validity?: NationaalBelangFullStartValidity
    Title?: string
    UUID?: string
    Weblink?: string
}

export type NationaalBelangEditWeblink = string | null

export type NationaalBelangEditTitle = string | null

export interface NationaalBelangEdit {
    Title?: NationaalBelangEditTitle
    Weblink?: NationaalBelangEditWeblink
}

export type NationaalBelangCreateStaticsOwner2UUID = string | null

export type NationaalBelangCreateStaticsOwner1UUID = string | null

export interface NationaalBelangCreateStatics {
    Owner_1_UUID?: NationaalBelangCreateStaticsOwner1UUID
    Owner_2_UUID?: NationaalBelangCreateStaticsOwner2UUID
}

export type NationaalBelangCreateWeblink = string | null

export interface NationaalBelangCreate {
    ObjectStatics?: NationaalBelangCreateStatics
    Title?: string
    Weblink?: NationaalBelangCreateWeblink
}

export interface NationaalBelangBasic {
    Code?: string
    Created_Date?: string
    Modified_Date?: string
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
    Weblink?: string
}

export type MutationStrategy =
    (typeof MutationStrategy)[keyof typeof MutationStrategy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MutationStrategy = {
    renvooi: 'renvooi',
    replace: 'replace',
} as const

export type MotivationNumber = string | null

export interface Motivation {
    Appendices?: Appendix[]
    Content: string
    Number?: MotivationNumber
    Title: string
}

export type ModuleStatusCode =
    (typeof ModuleStatusCode)[keyof typeof ModuleStatusCode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleStatusCode = {
    Ontwerp_GS_Concept: 'Ontwerp GS Concept',
    Ontwerp_GS: 'Ontwerp GS',
    Ontwerp_PS: 'Ontwerp PS',
    Ter_Inzage: 'Ter Inzage',
    Definitief_ontwerp_GS_Concept: 'Definitief ontwerp GS Concept',
    Definitief_ontwerp_GS: 'Definitief ontwerp GS',
    Definitief_ontwerp_PS: 'Definitief ontwerp PS',
    Vastgesteld: 'Vastgesteld',
} as const

export interface ModuleStatus {
    Created_By_UUID: string
    Created_Date: string
    ID: number
    Module_ID: number
    Status: string
}

export type ModuleSortColumn =
    (typeof ModuleSortColumn)[keyof typeof ModuleSortColumn]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleSortColumn = {
    Module_ID: 'Module_ID',
    Title: 'Title',
    Created_Date: 'Created_Date',
    Modified_Date: 'Modified_Date',
    Activated: 'Activated',
    Closed: 'Closed',
    Successful: 'Successful',
    Temporary_Locked: 'Temporary_Locked',
} as const

export type ModuleSnapshotObjectsItem = { [key: string]: unknown }

export interface ModuleSnapshot {
    Objects: ModuleSnapshotObjectsItem[]
}

export type ModuleShortStatus = ModuleStatus | null

export type ModuleShortModuleManager2 = UserShort | null

export type ModuleShortModuleManager1 = UserShort | null

export interface ModuleShort {
    Closed: boolean
    Description: string
    Module_ID: number
    Module_Manager_1?: ModuleShortModuleManager1
    Module_Manager_2?: ModuleShortModuleManager2
    Status?: ModuleShortStatus
    Title: string
}

export interface ModulePatchStatus {
    Status: ModuleStatusCode
}

export interface ModuleOverviewResponse {
    Module: Module
    StatusHistory: ModuleStatus[]
}

export type ModuleObjectsResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModel =

        | AmbitieBasic
        | BeleidsdoelBasic
        | BeleidskeuzeBasic
        | BeleidsregelBasic
        | DocumentBasic
        | GebiedsprogrammaBasic
        | MaatregelBasic
        | NationaalBelangBasic
        | GebiedengroepBasic
        | GebiedBasic
        | GebiedsaanwijzingBasic
        | ProgrammaAlgemeenBasic
        | VerplichtProgrammaBasic
        | VisieAlgemeenBasic
        | WerkingsgebiedBasic
        | WettelijkeTaakBasic

export interface ModuleObjectsResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasic {
    Model: ModuleObjectsResponseUnionAmbitieBasicBeleidsdoelBasicBeleidskeuzeBasicBeleidsregelBasicDocumentBasicGebiedsprogrammaBasicMaatregelBasicNationaalBelangBasicGebiedengroepBasicGebiedBasicGebiedsaanwijzingBasicProgrammaAlgemeenBasicVerplichtProgrammaBasicVisieAlgemeenBasicWerkingsgebiedBasicWettelijkeTaakBasicModel
    Module_ID: number
    Module_Latest_Status: string
    ModuleObjectContext: ModuleObjectContextShort
    Object_Type: string
    ObjectStatics: ObjectStaticShort
}

export type ModuleObjectContextShortOriginalAdjustOn = string | null

export interface ModuleObjectContextShort {
    Action: string
    Original_Adjust_On?: ModuleObjectContextShortOriginalAdjustOn
}

export type ModuleObjectContextOriginalAdjustOn = string | null

export type ModuleObjectContextModifiedBy = UserShort | null

export type ModuleObjectContextCreatedBy = UserShort | null

export interface ModuleObjectContext {
    Action: string
    Code: string
    Conclusion: string
    Created_By?: ModuleObjectContextCreatedBy
    Created_Date: string
    Explanation: string
    Modified_By?: ModuleObjectContextModifiedBy
    Modified_Date: string
    Module_ID: number
    Object_ID: number
    Object_Type: string
    Original_Adjust_On?: ModuleObjectContextOriginalAdjustOn
}

export type ModuleObjectActionFull =
    (typeof ModuleObjectActionFull)[keyof typeof ModuleObjectActionFull]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleObjectActionFull = {
    Create: 'Create',
    Edit: 'Edit',
    Terminate: 'Terminate',
} as const

export type ModuleObjectAction =
    (typeof ModuleObjectAction)[keyof typeof ModuleObjectAction]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleObjectAction = {
    Edit: 'Edit',
    Terminate: 'Terminate',
} as const

export type ModuleEditObjectContextExplanation = string | null

export type ModuleEditObjectContextConclusion = string | null

export type ModuleEditObjectContextAction = ModuleObjectAction | null

export interface ModuleEditObjectContext {
    Action?: ModuleEditObjectContextAction
    Conclusion?: ModuleEditObjectContextConclusion
    Explanation?: ModuleEditObjectContextExplanation
}

export type ModuleEditTitle = string | null

export type ModuleEditTemporaryLocked = boolean | null

export type ModuleEditModuleManager2UUID = string | null

export type ModuleEditModuleManager1UUID = string | null

export type ModuleEditDescription = string | null

export interface ModuleEdit {
    Description?: ModuleEditDescription
    Module_Manager_1_UUID?: ModuleEditModuleManager1UUID
    Module_Manager_2_UUID?: ModuleEditModuleManager2UUID
    Temporary_Locked?: ModuleEditTemporaryLocked
    Title?: ModuleEditTitle
}

export interface ModuleCreatedResponse {
    Module_ID: number
}

export type ModuleCreateModuleManager2UUID = string | null

export interface ModuleCreate {
    /** @minLength 3 */
    Description: string
    Module_Manager_1_UUID: string
    Module_Manager_2_UUID?: ModuleCreateModuleManager2UUID
    /** @minLength 3 */
    Title: string
}

export type ModuleAddNewObjectOwner2UUID = string | null

export type ModuleAddNewObjectClient1UUID = string | null

export interface ModuleAddNewObject {
    Client_1_UUID?: ModuleAddNewObjectClient1UUID
    Conclusion?: string
    Explanation?: string
    Object_Type: string
    Owner_1_UUID: string
    Owner_2_UUID?: ModuleAddNewObjectOwner2UUID
    /** @minLength 3 */
    Title: string
}

export interface ModuleAddExistingObject {
    Action: ModuleObjectAction
    Conclusion?: string
    Explanation?: string
    Object_UUID: string
}

export type ModuleStatusProperty = ModuleStatus | null

export type ModuleModuleManager2UUID = string | null

export type ModuleModuleManager2 = UserShort | null

export type ModuleModuleManager1 = UserShort | null

export type ModuleModifiedBy = UserShort | null

export type ModuleCreatedBy = UserShort | null

export interface Module {
    Activated: boolean
    Closed: boolean
    Created_By?: ModuleCreatedBy
    Created_By_UUID: string
    Created_Date: string
    Description: string
    Modified_By?: ModuleModifiedBy
    Modified_By_UUID: string
    Modified_Date: string
    Module_ID: number
    Module_Manager_1?: ModuleModuleManager1
    Module_Manager_1_UUID: string
    Module_Manager_2?: ModuleModuleManager2
    Module_Manager_2_UUID?: ModuleModuleManager2UUID
    Status?: ModuleStatusProperty
    Successful: boolean
    Temporary_Locked: boolean
    Title: string
}

export interface MaatregelUUID {
    Object_ID?: number
    UUID?: string
}

export type MaatregelStaticStaticsPortfolioHolder2 = UserShort | null

export type MaatregelStaticStaticsPortfolioHolder1 = UserShort | null

export type MaatregelStaticStaticsOwner2 = UserShort | null

export type MaatregelStaticStaticsOwner1 = UserShort | null

export type MaatregelStaticStaticsClient1 = UserShort | null

export interface MaatregelStaticStatics {
    Client_1?: MaatregelStaticStaticsClient1
    Owner_1?: MaatregelStaticStaticsOwner1
    Owner_2?: MaatregelStaticStaticsOwner2
    Portfolio_Holder_1?: MaatregelStaticStaticsPortfolioHolder1
    Portfolio_Holder_2?: MaatregelStaticStaticsPortfolioHolder2
}

export type MaatregelStaticPostStaticsPortfolioHolder2UUID = string | null

export type MaatregelStaticPostStaticsPortfolioHolder1UUID = string | null

export type MaatregelStaticPostStaticsOwner2UUID = string | null

export type MaatregelStaticPostStaticsOwner1UUID = string | null

export type MaatregelStaticPostStaticsClient1UUID = string | null

export interface MaatregelStaticPostStatics {
    Client_1_UUID?: MaatregelStaticPostStaticsClient1UUID
    Owner_1_UUID?: MaatregelStaticPostStaticsOwner1UUID
    Owner_2_UUID?: MaatregelStaticPostStaticsOwner2UUID
    Portfolio_Holder_1_UUID?: MaatregelStaticPostStaticsPortfolioHolder1UUID
    Portfolio_Holder_2_UUID?: MaatregelStaticPostStaticsPortfolioHolder2UUID
}

export type MaatregelPatchWerkingsgebiedCode = string | null

export type MaatregelPatchTitle = string | null

export type MaatregelPatchThemas = string[] | null

export type MaatregelPatchRole = string | null

export type MaatregelPatchHierarchyCode = string | null

export type MaatregelPatchGebiedengroepCode = string | null

export type MaatregelPatchEffect = string | null

export type MaatregelPatchDocuments = string[] | null

export type MaatregelPatchDescription = string | null

export interface MaatregelPatch {
    Description?: MaatregelPatchDescription
    Documents?: MaatregelPatchDocuments
    Effect?: MaatregelPatchEffect
    Gebiedengroep_Code?: MaatregelPatchGebiedengroepCode
    Hierarchy_Code?: MaatregelPatchHierarchyCode
    Role?: MaatregelPatchRole
    Themas?: MaatregelPatchThemas
    Title?: MaatregelPatchTitle
    Werkingsgebied_Code?: MaatregelPatchWerkingsgebiedCode
}

export interface MaatregelMinimal {
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type MaatregelFullStaticsPortfolioHolder2 = UserShort | null

export type MaatregelFullStaticsPortfolioHolder1 = UserShort | null

export type MaatregelFullStaticsOwner2 = UserShort | null

export type MaatregelFullStaticsOwner1 = UserShort | null

export type MaatregelFullStaticsClient1 = UserShort | null

export interface MaatregelFullStatics {
    Client_1?: MaatregelFullStaticsClient1
    Owner_1?: MaatregelFullStaticsOwner1
    Owner_2?: MaatregelFullStaticsOwner2
    Portfolio_Holder_1?: MaatregelFullStaticsPortfolioHolder1
    Portfolio_Holder_2?: MaatregelFullStaticsPortfolioHolder2
}

export type MaatregelFullWerkingsgebiedStatics = WerkingsgebiedStatics | null

export type MaatregelFullWerkingsgebied = WerkingsgebiedBasic | null

export type MaatregelFullStartValidity = string | null

export type MaatregelFullNextVersion = NextObjectVersion | null

export type MaatregelFullModifiedBy = UserShort | null

export type MaatregelFullHierarchyStatics = HierarchyStatics | null

export type MaatregelFullGebiedengroepStatic = ObjectStatics | null

export type MaatregelFullGebiedengroepCode = string | null

export type MaatregelFullEndValidity = string | null

export type MaatregelFullCreatedBy = UserShort | null

export type MaatregelFullAdjustOn = string | null

export interface MaatregelFull {
    Adjust_On?: MaatregelFullAdjustOn
    Beleidskeuzes?: ReadRelationShortBeleidskeuzeMinimal[]
    Code?: string
    Created_By?: MaatregelFullCreatedBy
    Created_Date?: string
    Description?: string
    Documents?: string[]
    Documents_Statics?: ObjectStatics[]
    Effect?: string
    End_Validity?: MaatregelFullEndValidity
    Gebiedengroep_Code?: MaatregelFullGebiedengroepCode
    Gebiedengroep_Static?: MaatregelFullGebiedengroepStatic
    Gebiedsaanwijzingen_Statics?: ObjectStatics[]
    Gebiedsprogrammas?: ReadRelationShortGebiedsprogrammaMinimal[]
    Hierarchy_Code?: string
    Hierarchy_Statics?: MaatregelFullHierarchyStatics
    Modified_By?: MaatregelFullModifiedBy
    Modified_Date?: string
    Next_Version?: MaatregelFullNextVersion
    Object_ID?: number
    ObjectStatics?: MaatregelFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Role?: string
    Start_Validity?: MaatregelFullStartValidity
    Themas?: string[]
    Title?: string
    UUID?: string
    Werkingsgebied?: MaatregelFullWerkingsgebied
    Werkingsgebied_Code?: string
    Werkingsgebied_Statics?: MaatregelFullWerkingsgebiedStatics
}

export type MaatregelExtendedStaticsPortfolioHolder2 = UserShort | null

export type MaatregelExtendedStaticsPortfolioHolder1 = UserShort | null

export type MaatregelExtendedStaticsOwner2 = UserShort | null

export type MaatregelExtendedStaticsOwner1 = UserShort | null

export type MaatregelExtendedStaticsClient1 = UserShort | null

export interface MaatregelExtendedStatics {
    Client_1?: MaatregelExtendedStaticsClient1
    Owner_1?: MaatregelExtendedStaticsOwner1
    Owner_2?: MaatregelExtendedStaticsOwner2
    Portfolio_Holder_1?: MaatregelExtendedStaticsPortfolioHolder1
    Portfolio_Holder_2?: MaatregelExtendedStaticsPortfolioHolder2
}

export type MaatregelExtendedStartValidity = string | null

export type MaatregelExtendedModifiedBy = UserShort | null

export type MaatregelExtendedGebiedengroepCode = string | null

export type MaatregelExtendedEndValidity = string | null

export type MaatregelExtendedCreatedBy = UserShort | null

export type MaatregelExtendedAdjustOn = string | null

export interface MaatregelExtended {
    Adjust_On?: MaatregelExtendedAdjustOn
    Code?: string
    Created_By?: MaatregelExtendedCreatedBy
    Created_Date?: string
    End_Validity?: MaatregelExtendedEndValidity
    Gebiedengroep_Code?: MaatregelExtendedGebiedengroepCode
    Hierarchy_Code?: string
    Modified_By?: MaatregelExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: MaatregelExtendedStatics
    Start_Validity?: MaatregelExtendedStartValidity
    Themas?: string[]
    Title?: string
    UUID?: string
    Werkingsgebied_Code?: string
}

export type MaatregelBasicStartValidity = string | null

export type MaatregelBasicNextVersion = NextObjectVersion | null

export type MaatregelBasicEndValidity = string | null

export type MaatregelBasicAdjustOn = string | null

export interface MaatregelBasic {
    Adjust_On?: MaatregelBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: MaatregelBasicEndValidity
    Modified_Date?: string
    Next_Version?: MaatregelBasicNextVersion
    Object_ID?: number
    Start_Validity?: MaatregelBasicStartValidity
    Title?: string
    UUID?: string
}

export interface ListThemaResponse {
    themas: Thema[]
}

export interface ListAreaDesignationResponse {
    gebiedsaanwijzingen: Gebiedsaanwijzing[]
}

export type InputGeoWerkingsgebiedenSortColumn =
    (typeof InputGeoWerkingsgebiedenSortColumn)[keyof typeof InputGeoWerkingsgebiedenSortColumn]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InputGeoWerkingsgebiedenSortColumn = {
    Title: 'Title',
    Created_Date: 'Created_Date',
} as const

export interface InputGeoWerkingsgebied {
    Created_Date: string
    Description: string
    Title: string
    UUID: string
}

export interface InputGeoOnderverdeling {
    Created_Date: string
    Description: string
    Geometry_Hash: string
    Title: string
    UUID: string
}

export interface InputGeoWerkingsgebiedDetailed {
    Created_Date: string
    Description: string
    Onderverdelingen: InputGeoOnderverdeling[]
    Title: string
    UUID: string
}

export interface HierarchyStatics {
    Cached_Title: string
    Code: string
    Object_ID: number
    Object_Type: string
}

export type HierachyReferenceTitle = string | null

export interface HierachyReference {
    Code: string
    Hierarchy_Code: string
    Object_ID: number
    Object_Type: string
    Title?: HierachyReferenceTitle
    UUID: string
}

export interface HTTPValidationError {
    detail?: ValidationError[]
}

export interface GraphVertice {
    Code: string
    Object_ID: number
    Object_Type: string
    Title: string
    UUID: string
}

export type GraphEdgeType = (typeof GraphEdgeType)[keyof typeof GraphEdgeType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GraphEdgeType = {
    relation: 'relation',
    acknowledged_relation: 'acknowledged_relation',
    hierarchy_code: 'hierarchy_code',
} as const

export interface GraphEdge {
    Type: GraphEdgeType
    Vertice_A_Code: string
    Vertice_B_Code: string
}

export interface GraphResponse {
    Edges: GraphEdge[]
    Vertices: GraphVertice[]
}

export interface GebiedsprogrammaUUID {
    Object_ID?: number
    UUID?: string
}

export type GebiedsprogrammaStaticStaticsPortfolioHolder2 = UserShort | null

export type GebiedsprogrammaStaticStaticsPortfolioHolder1 = UserShort | null

export type GebiedsprogrammaStaticStaticsOwner2 = UserShort | null

export type GebiedsprogrammaStaticStaticsOwner1 = UserShort | null

export type GebiedsprogrammaStaticStaticsClient1 = UserShort | null

export interface GebiedsprogrammaStaticStatics {
    Client_1?: GebiedsprogrammaStaticStaticsClient1
    Owner_1?: GebiedsprogrammaStaticStaticsOwner1
    Owner_2?: GebiedsprogrammaStaticStaticsOwner2
    Portfolio_Holder_1?: GebiedsprogrammaStaticStaticsPortfolioHolder1
    Portfolio_Holder_2?: GebiedsprogrammaStaticStaticsPortfolioHolder2
}

export type GebiedsprogrammaStaticPostStaticsPortfolioHolder2UUID =
    | string
    | null

export type GebiedsprogrammaStaticPostStaticsPortfolioHolder1UUID =
    | string
    | null

export type GebiedsprogrammaStaticPostStaticsOwner2UUID = string | null

export type GebiedsprogrammaStaticPostStaticsOwner1UUID = string | null

export type GebiedsprogrammaStaticPostStaticsClient1UUID = string | null

export interface GebiedsprogrammaStaticPostStatics {
    Client_1_UUID?: GebiedsprogrammaStaticPostStaticsClient1UUID
    Owner_1_UUID?: GebiedsprogrammaStaticPostStaticsOwner1UUID
    Owner_2_UUID?: GebiedsprogrammaStaticPostStaticsOwner2UUID
    Portfolio_Holder_1_UUID?: GebiedsprogrammaStaticPostStaticsPortfolioHolder1UUID
    Portfolio_Holder_2_UUID?: GebiedsprogrammaStaticPostStaticsPortfolioHolder2UUID
}

export type GebiedsprogrammaPatchTitle = string | null

export type GebiedsprogrammaPatchImage = string | null

export type GebiedsprogrammaPatchDescription = string | null

export interface GebiedsprogrammaPatch {
    Description?: GebiedsprogrammaPatchDescription
    Image?: GebiedsprogrammaPatchImage
    Title?: GebiedsprogrammaPatchTitle
}

export interface GebiedsprogrammaMinimal {
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type GebiedsprogrammaFullStaticsPortfolioHolder2 = UserShort | null

export type GebiedsprogrammaFullStaticsPortfolioHolder1 = UserShort | null

export type GebiedsprogrammaFullStaticsOwner2 = UserShort | null

export type GebiedsprogrammaFullStaticsOwner1 = UserShort | null

export type GebiedsprogrammaFullStaticsClient1 = UserShort | null

export interface GebiedsprogrammaFullStatics {
    Client_1?: GebiedsprogrammaFullStaticsClient1
    Owner_1?: GebiedsprogrammaFullStaticsOwner1
    Owner_2?: GebiedsprogrammaFullStaticsOwner2
    Portfolio_Holder_1?: GebiedsprogrammaFullStaticsPortfolioHolder1
    Portfolio_Holder_2?: GebiedsprogrammaFullStaticsPortfolioHolder2
}

export type GebiedsprogrammaFullStartValidity = string | null

export type GebiedsprogrammaFullNextVersion = NextObjectVersion | null

export type GebiedsprogrammaFullModifiedBy = UserShort | null

export type GebiedsprogrammaFullImage = string | null

export type GebiedsprogrammaFullEndValidity = string | null

export type GebiedsprogrammaFullCreatedBy = UserShort | null

export type GebiedsprogrammaFullAdjustOn = string | null

export interface GebiedsprogrammaFull {
    Adjust_On?: GebiedsprogrammaFullAdjustOn
    Code?: string
    Created_By?: GebiedsprogrammaFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: GebiedsprogrammaFullEndValidity
    Image?: GebiedsprogrammaFullImage
    Maatregelen?: ReadRelationShortMaatregelMinimal[]
    Modified_By?: GebiedsprogrammaFullModifiedBy
    Modified_Date?: string
    Next_Version?: GebiedsprogrammaFullNextVersion
    Object_ID?: number
    ObjectStatics?: GebiedsprogrammaFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: GebiedsprogrammaFullStartValidity
    Title?: string
    UUID?: string
}

export type GebiedsprogrammaExtendedStaticsPortfolioHolder2 = UserShort | null

export type GebiedsprogrammaExtendedStaticsPortfolioHolder1 = UserShort | null

export type GebiedsprogrammaExtendedStaticsOwner2 = UserShort | null

export type GebiedsprogrammaExtendedStaticsOwner1 = UserShort | null

export type GebiedsprogrammaExtendedStaticsClient1 = UserShort | null

export interface GebiedsprogrammaExtendedStatics {
    Client_1?: GebiedsprogrammaExtendedStaticsClient1
    Owner_1?: GebiedsprogrammaExtendedStaticsOwner1
    Owner_2?: GebiedsprogrammaExtendedStaticsOwner2
    Portfolio_Holder_1?: GebiedsprogrammaExtendedStaticsPortfolioHolder1
    Portfolio_Holder_2?: GebiedsprogrammaExtendedStaticsPortfolioHolder2
}

export type GebiedsprogrammaExtendedStartValidity = string | null

export type GebiedsprogrammaExtendedModifiedBy = UserShort | null

export type GebiedsprogrammaExtendedImage = string | null

export type GebiedsprogrammaExtendedEndValidity = string | null

export type GebiedsprogrammaExtendedCreatedBy = UserShort | null

export type GebiedsprogrammaExtendedAdjustOn = string | null

export interface GebiedsprogrammaExtended {
    Adjust_On?: GebiedsprogrammaExtendedAdjustOn
    Code?: string
    Created_By?: GebiedsprogrammaExtendedCreatedBy
    Created_Date?: string
    End_Validity?: GebiedsprogrammaExtendedEndValidity
    Image?: GebiedsprogrammaExtendedImage
    Modified_By?: GebiedsprogrammaExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: GebiedsprogrammaExtendedStatics
    Start_Validity?: GebiedsprogrammaExtendedStartValidity
    Title?: string
    UUID?: string
}

export type GebiedsprogrammaBasicStartValidity = string | null

export type GebiedsprogrammaBasicNextVersion = NextObjectVersion | null

export type GebiedsprogrammaBasicImage = string | null

export type GebiedsprogrammaBasicEndValidity = string | null

export type GebiedsprogrammaBasicAdjustOn = string | null

export interface GebiedsprogrammaBasic {
    Adjust_On?: GebiedsprogrammaBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: GebiedsprogrammaBasicEndValidity
    Image?: GebiedsprogrammaBasicImage
    Modified_Date?: string
    Next_Version?: GebiedsprogrammaBasicNextVersion
    Object_ID?: number
    Start_Validity?: GebiedsprogrammaBasicStartValidity
    Title?: string
    UUID?: string
}

export interface GebiedsaanwijzingWaarde {
    bron: string
    definitie: string
    deprecated: boolean
    domein: string
    label: string
    term: string
    toelichting: string
    uri: string
}

export interface GebiedsaanwijzingUUID {
    Object_ID?: number
    UUID?: string
}

export interface GebiedsaanwijzingType {
    bron: string
    definitie: string
    deprecated: boolean
    domein: string
    label: string
    term: string
    uri: string
}

export type GebiedsaanwijzingStaticStaticsOwner2 = UserShort | null

export type GebiedsaanwijzingStaticStaticsOwner1 = UserShort | null

export interface GebiedsaanwijzingStaticStatics {
    Owner_1?: GebiedsaanwijzingStaticStaticsOwner1
    Owner_2?: GebiedsaanwijzingStaticStaticsOwner2
}

export type GebiedsaanwijzingStaticPostStaticsOwner2UUID = string | null

export type GebiedsaanwijzingStaticPostStaticsOwner1UUID = string | null

export interface GebiedsaanwijzingStaticPostStatics {
    Owner_1_UUID?: GebiedsaanwijzingStaticPostStaticsOwner1UUID
    Owner_2_UUID?: GebiedsaanwijzingStaticPostStaticsOwner2UUID
}

export type GebiedsaanwijzingPatchTitle = string | null

export interface GebiedsaanwijzingPatch {
    Ref_Group?: string
    Ref_Type?: string
    Target_Codes?: string[]
    Title?: GebiedsaanwijzingPatchTitle
}

export interface GebiedsaanwijzingGroep {
    label: string
    omschrijving: string
    titel: string
    toelichting: string
    uri: string
}

export type GebiedsaanwijzingFullStaticsOwner2 = UserShort | null

export type GebiedsaanwijzingFullStaticsOwner1 = UserShort | null

export interface GebiedsaanwijzingFullStatics {
    Owner_1?: GebiedsaanwijzingFullStaticsOwner1
    Owner_2?: GebiedsaanwijzingFullStaticsOwner2
}

export type GebiedsaanwijzingFullStartValidity = string | null

export type GebiedsaanwijzingFullModifiedBy = UserShort | null

export type GebiedsaanwijzingFullEndValidity = string | null

export type GebiedsaanwijzingFullCreatedBy = UserShort | null

export type GebiedsaanwijzingFullAdjustOn = string | null

export interface GebiedsaanwijzingFull {
    Adjust_On?: GebiedsaanwijzingFullAdjustOn
    Code?: string
    Created_By?: GebiedsaanwijzingFullCreatedBy
    Created_Date?: string
    End_Validity?: GebiedsaanwijzingFullEndValidity
    Geo_Statics?: ObjectStatics[]
    Modified_By?: GebiedsaanwijzingFullModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: GebiedsaanwijzingFullStatics
    Ref_Group?: string
    Ref_Type?: string
    Start_Validity?: GebiedsaanwijzingFullStartValidity
    Target_Codes?: string[]
    Title?: string
    UUID?: string
}

export type GebiedsaanwijzingExtendedStaticsOwner2 = UserShort | null

export type GebiedsaanwijzingExtendedStaticsOwner1 = UserShort | null

export interface GebiedsaanwijzingExtendedStatics {
    Owner_1?: GebiedsaanwijzingExtendedStaticsOwner1
    Owner_2?: GebiedsaanwijzingExtendedStaticsOwner2
}

export type GebiedsaanwijzingExtendedStartValidity = string | null

export type GebiedsaanwijzingExtendedModifiedBy = UserShort | null

export type GebiedsaanwijzingExtendedEndValidity = string | null

export type GebiedsaanwijzingExtendedCreatedBy = UserShort | null

export type GebiedsaanwijzingExtendedAdjustOn = string | null

export interface GebiedsaanwijzingExtended {
    Adjust_On?: GebiedsaanwijzingExtendedAdjustOn
    Code?: string
    Created_By?: GebiedsaanwijzingExtendedCreatedBy
    Created_Date?: string
    End_Validity?: GebiedsaanwijzingExtendedEndValidity
    Modified_By?: GebiedsaanwijzingExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: GebiedsaanwijzingExtendedStatics
    Ref_Group?: string
    Ref_Type?: string
    Start_Validity?: GebiedsaanwijzingExtendedStartValidity
    Target_Codes?: string[]
    Title?: string
    UUID?: string
}

export type GebiedsaanwijzingBasicStartValidity = string | null

export type GebiedsaanwijzingBasicEndValidity = string | null

export type GebiedsaanwijzingBasicAdjustOn = string | null

export interface GebiedsaanwijzingBasic {
    Adjust_On?: GebiedsaanwijzingBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: GebiedsaanwijzingBasicEndValidity
    Modified_Date?: string
    Object_ID?: number
    Start_Validity?: GebiedsaanwijzingBasicStartValidity
    Title?: string
    UUID?: string
}

export interface Gebiedsaanwijzing {
    aanwijzing_groep: GebiedsaanwijzingGroep
    aanwijzing_type: GebiedsaanwijzingType
    waardes: GebiedsaanwijzingWaarde[]
}

export interface GebiedengroepUUID {
    Object_ID?: number
    UUID?: string
}

export type GebiedengroepStaticStaticsOwner2 = UserShort | null

export type GebiedengroepStaticStaticsOwner1 = UserShort | null

export interface GebiedengroepStaticStatics {
    Owner_1?: GebiedengroepStaticStaticsOwner1
    Owner_2?: GebiedengroepStaticStaticsOwner2
}

export type GebiedengroepStaticPostStaticsOwner2UUID = string | null

export type GebiedengroepStaticPostStaticsOwner1UUID = string | null

export interface GebiedengroepStaticPostStatics {
    Owner_1_UUID?: GebiedengroepStaticPostStaticsOwner1UUID
    Owner_2_UUID?: GebiedengroepStaticPostStaticsOwner2UUID
}

export type GebiedengroepPatchTitle = string | null

export type GebiedengroepPatchSourceTitle = string | null

export type GebiedengroepPatchDescription = string | null

export interface GebiedengroepPatch {
    Description?: GebiedengroepPatchDescription
    Source_Title?: GebiedengroepPatchSourceTitle
    Title?: GebiedengroepPatchTitle
}

export type GebiedengroepFullStaticsOwner2 = UserShort | null

export type GebiedengroepFullStaticsOwner1 = UserShort | null

export interface GebiedengroepFullStatics {
    Owner_1?: GebiedengroepFullStaticsOwner1
    Owner_2?: GebiedengroepFullStaticsOwner2
}

export type GebiedengroepFullStartValidity = string | null

export type GebiedengroepFullSourceUUID = string | null

export type GebiedengroepFullModifiedBy = UserShort | null

export type GebiedengroepFullEndValidity = string | null

export type GebiedengroepFullCreatedBy = UserShort | null

export type GebiedengroepFullAdjustOn = string | null

export interface GebiedengroepFull {
    Adjust_On?: GebiedengroepFullAdjustOn
    Code?: string
    Created_By?: GebiedengroepFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: GebiedengroepFullEndValidity
    Gebieden?: string[]
    Gebieden_Statics?: ObjectStatics[]
    Modified_By?: GebiedengroepFullModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: GebiedengroepFullStatics
    Source_Title?: string
    Source_UUID?: GebiedengroepFullSourceUUID
    Start_Validity?: GebiedengroepFullStartValidity
    Title?: string
    UUID?: string
}

export type GebiedengroepExtendedStaticsOwner2 = UserShort | null

export type GebiedengroepExtendedStaticsOwner1 = UserShort | null

export interface GebiedengroepExtendedStatics {
    Owner_1?: GebiedengroepExtendedStaticsOwner1
    Owner_2?: GebiedengroepExtendedStaticsOwner2
}

export type GebiedengroepExtendedStartValidity = string | null

export type GebiedengroepExtendedSourceUUID = string | null

export type GebiedengroepExtendedModifiedBy = UserShort | null

export type GebiedengroepExtendedEndValidity = string | null

export type GebiedengroepExtendedCreatedBy = UserShort | null

export type GebiedengroepExtendedAdjustOn = string | null

export interface GebiedengroepExtended {
    Adjust_On?: GebiedengroepExtendedAdjustOn
    Code?: string
    Created_By?: GebiedengroepExtendedCreatedBy
    Created_Date?: string
    End_Validity?: GebiedengroepExtendedEndValidity
    Gebieden?: string[]
    Modified_By?: GebiedengroepExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: GebiedengroepExtendedStatics
    Source_Title?: string
    Source_UUID?: GebiedengroepExtendedSourceUUID
    Start_Validity?: GebiedengroepExtendedStartValidity
    Title?: string
    UUID?: string
}

export type GebiedengroepBasicStartValidity = string | null

export type GebiedengroepBasicEndValidity = string | null

export type GebiedengroepBasicAdjustOn = string | null

export interface GebiedengroepBasic {
    Adjust_On?: GebiedengroepBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: GebiedengroepBasicEndValidity
    Modified_Date?: string
    Object_ID?: number
    Source_Title?: string
    Start_Validity?: GebiedengroepBasicStartValidity
    Title?: string
    UUID?: string
}

export interface GebiedUUID {
    Object_ID?: number
    UUID?: string
}

export type GebiedStaticStaticsOwner2 = UserShort | null

export type GebiedStaticStaticsOwner1 = UserShort | null

export interface GebiedStaticStatics {
    Owner_1?: GebiedStaticStaticsOwner1
    Owner_2?: GebiedStaticStaticsOwner2
}

export type GebiedStaticPostStaticsOwner2UUID = string | null

export type GebiedStaticPostStaticsOwner1UUID = string | null

export interface GebiedStaticPostStatics {
    Owner_1_UUID?: GebiedStaticPostStaticsOwner1UUID
    Owner_2_UUID?: GebiedStaticPostStaticsOwner2UUID
}

export type GebiedPatchTitle = string | null

export interface GebiedPatch {
    Title?: GebiedPatchTitle
}

export type GebiedFullStaticsOwner2 = UserShort | null

export type GebiedFullStaticsOwner1 = UserShort | null

export interface GebiedFullStatics {
    Owner_1?: GebiedFullStaticsOwner1
    Owner_2?: GebiedFullStaticsOwner2
}

export type GebiedFullStartValidity = string | null

export type GebiedFullNextVersion = NextObjectVersion | null

export type GebiedFullModifiedBy = UserShort | null

export type GebiedFullEndValidity = string | null

export type GebiedFullCreatedBy = UserShort | null

export type GebiedFullAreaUUID = string | null

export type GebiedFullArea = AreaBasic | null

export type GebiedFullAdjustOn = string | null

export interface GebiedFull {
    Adjust_On?: GebiedFullAdjustOn
    Area?: GebiedFullArea
    Area_UUID?: GebiedFullAreaUUID
    Code?: string
    Created_By?: GebiedFullCreatedBy
    Created_Date?: string
    End_Validity?: GebiedFullEndValidity
    Modified_By?: GebiedFullModifiedBy
    Modified_Date?: string
    Next_Version?: GebiedFullNextVersion
    Object_ID?: number
    ObjectStatics?: GebiedFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: GebiedFullStartValidity
    Title?: string
    UUID?: string
}

export type GebiedExtendedStaticsOwner2 = UserShort | null

export type GebiedExtendedStaticsOwner1 = UserShort | null

export interface GebiedExtendedStatics {
    Owner_1?: GebiedExtendedStaticsOwner1
    Owner_2?: GebiedExtendedStaticsOwner2
}

export type GebiedExtendedStartValidity = string | null

export type GebiedExtendedModifiedBy = UserShort | null

export type GebiedExtendedEndValidity = string | null

export type GebiedExtendedCreatedBy = UserShort | null

export type GebiedExtendedAreaUUID = string | null

export type GebiedExtendedAdjustOn = string | null

export interface GebiedExtended {
    Adjust_On?: GebiedExtendedAdjustOn
    Area_UUID?: GebiedExtendedAreaUUID
    Code?: string
    Created_By?: GebiedExtendedCreatedBy
    Created_Date?: string
    End_Validity?: GebiedExtendedEndValidity
    Modified_By?: GebiedExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: GebiedExtendedStatics
    Start_Validity?: GebiedExtendedStartValidity
    Title?: string
    UUID?: string
}

export type GebiedBasicStartValidity = string | null

export type GebiedBasicEndValidity = string | null

export type GebiedBasicAreaUUID = string | null

export type GebiedBasicAdjustOn = string | null

export interface GebiedBasic {
    Adjust_On?: GebiedBasicAdjustOn
    Area_UUID?: GebiedBasicAreaUUID
    Code?: string
    Created_Date?: string
    End_Validity?: GebiedBasicEndValidity
    Modified_Date?: string
    Object_ID?: number
    Start_Validity?: GebiedBasicStartValidity
    Title?: string
    UUID?: string
}

export type ErrorDetailsLocItem = number | string

export type ErrorDetailsCtx = { [key: string]: unknown }

export interface ErrorDetails {
    ctx?: ErrorDetailsCtx
    input: unknown
    loc: ErrorDetailsLocItem[]
    msg: string
    type: string
    url?: string
}

export type EnvironmentEditTitle = string | null

export type EnvironmentEditSubmitterID = string | null

export type EnvironmentEditProvinceID = string | null

export type EnvironmentEditIsActive = boolean | null

export type EnvironmentEditFrbrLanguage = string | null

export type EnvironmentEditFrbrCountry = string | null

export type EnvironmentEditDescription = string | null

export type EnvironmentEditCanValidate = boolean | null

export type EnvironmentEditCanPublicate = boolean | null

export type EnvironmentEditAuthorityID = string | null

export interface EnvironmentEdit {
    Authority_ID?: EnvironmentEditAuthorityID
    Can_Publicate?: EnvironmentEditCanPublicate
    Can_Validate?: EnvironmentEditCanValidate
    Description?: EnvironmentEditDescription
    Frbr_Country?: EnvironmentEditFrbrCountry
    Frbr_Language?: EnvironmentEditFrbrLanguage
    Is_Active?: EnvironmentEditIsActive
    Province_ID?: EnvironmentEditProvinceID
    Submitter_ID?: EnvironmentEditSubmitterID
    Title?: EnvironmentEditTitle
}

export interface EnvironmentCreatedResponse {
    UUID: string
}

export interface EnvironmentCreate {
    Authority_ID: string
    Can_Publicate: boolean
    Can_Validate: boolean
    Description: string
    Frbr_Country: string
    Frbr_Language: string
    Has_State: boolean
    Province_ID: string
    Submitter_ID: string
    /** @minLength 3 */
    Title: string
}

export type EditUserRol = string | null

export type EditUserIsActive = boolean | null

export type EditUserGebruikersnaam = string | null

export type EditUserEmail = string | null

export interface EditUser {
    Email?: EditUserEmail
    Gebruikersnaam?: EditUserGebruikersnaam
    IsActive?: EditUserIsActive
    Rol?: EditUserRol
}

export type EditAcknowledgedRelationExplanation = string | null

export type EditAcknowledgedRelationDenied = boolean | null

export type EditAcknowledgedRelationDeleted = boolean | null

export type EditAcknowledgedRelationAcknowledged = boolean | null

export interface EditAcknowledgedRelation {
    Acknowledged?: EditAcknowledgedRelationAcknowledged
    Deleted?: EditAcknowledgedRelationDeleted
    Denied?: EditAcknowledgedRelationDenied
    Explanation?: EditAcknowledgedRelationExplanation
    Object_ID: number
    Object_Type: string
}

export interface DocumentUUID {
    Object_ID?: number
    UUID?: string
}

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentType = {
    omgevingsvisie: 'omgevingsvisie',
    programma: 'programma',
} as const

export type DocumentStaticStaticsOwner2 = UserShort | null

export type DocumentStaticStaticsOwner1 = UserShort | null

export interface DocumentStaticStatics {
    Owner_1?: DocumentStaticStaticsOwner1
    Owner_2?: DocumentStaticStaticsOwner2
}

export type DocumentStaticPostStaticsOwner2UUID = string | null

export type DocumentStaticPostStaticsOwner1UUID = string | null

export interface DocumentStaticPostStatics {
    Owner_1_UUID?: DocumentStaticPostStaticsOwner1UUID
    Owner_2_UUID?: DocumentStaticPostStaticsOwner2UUID
}

export type DocumentPatchTitle = string | null

export type DocumentPatchFilename = string | null

export type DocumentPatchFileUUID = string | null

export type DocumentPatchDescription = string | null

export interface DocumentPatch {
    Description?: DocumentPatchDescription
    File_UUID?: DocumentPatchFileUUID
    Filename?: DocumentPatchFilename
    Title?: DocumentPatchTitle
}

export type DocumentFullStaticsOwner2 = UserShort | null

export type DocumentFullStaticsOwner1 = UserShort | null

export interface DocumentFullStatics {
    Owner_1?: DocumentFullStaticsOwner1
    Owner_2?: DocumentFullStaticsOwner2
}

export type DocumentFullStartValidity = string | null

export type DocumentFullNextVersion = NextObjectVersion | null

export type DocumentFullModifiedBy = UserShort | null

export type DocumentFullFileUUID = string | null

export type DocumentFullFile = StorageFileBasic | null

export type DocumentFullEndValidity = string | null

export type DocumentFullCreatedBy = UserShort | null

export type DocumentFullAdjustOn = string | null

export interface DocumentFull {
    Adjust_On?: DocumentFullAdjustOn
    Code?: string
    Created_By?: DocumentFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: DocumentFullEndValidity
    File?: DocumentFullFile
    File_UUID?: DocumentFullFileUUID
    Filename?: string
    Modified_By?: DocumentFullModifiedBy
    Modified_Date?: string
    Next_Version?: DocumentFullNextVersion
    Object_ID?: number
    ObjectStatics?: DocumentFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: DocumentFullStartValidity
    Title?: string
    UUID?: string
}

export type DocumentExtendedStaticsOwner2 = UserShort | null

export type DocumentExtendedStaticsOwner1 = UserShort | null

export interface DocumentExtendedStatics {
    Owner_1?: DocumentExtendedStaticsOwner1
    Owner_2?: DocumentExtendedStaticsOwner2
}

export type DocumentExtendedStartValidity = string | null

export type DocumentExtendedModifiedBy = UserShort | null

export type DocumentExtendedFileUUID = string | null

export type DocumentExtendedEndValidity = string | null

export type DocumentExtendedCreatedBy = UserShort | null

export type DocumentExtendedAdjustOn = string | null

export interface DocumentExtended {
    Adjust_On?: DocumentExtendedAdjustOn
    Code?: string
    Created_By?: DocumentExtendedCreatedBy
    Created_Date?: string
    End_Validity?: DocumentExtendedEndValidity
    File_UUID?: DocumentExtendedFileUUID
    Filename?: string
    Modified_By?: DocumentExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: DocumentExtendedStatics
    Start_Validity?: DocumentExtendedStartValidity
    Title?: string
    UUID?: string
}

export type DocumentBasicStartValidity = string | null

export type DocumentBasicNextVersion = NextObjectVersion | null

export type DocumentBasicFileUUID = string | null

export type DocumentBasicEndValidity = string | null

export type DocumentBasicAdjustOn = string | null

export interface DocumentBasic {
    Adjust_On?: DocumentBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: DocumentBasicEndValidity
    File_UUID?: DocumentBasicFileUUID
    Filename?: string
    Modified_Date?: string
    Next_Version?: DocumentBasicNextVersion
    Object_ID?: number
    Start_Validity?: DocumentBasicStartValidity
    Title?: string
    UUID?: string
}

export type CompleteModuleStartValidity = string | null

export interface CompleteModule {
    start_validity?: CompleteModuleStartValidity
}

export interface BodyStorageFilePostFilesUpload {
    ignore_report: boolean
    title: string
    uploaded_file: string
}

export interface BodyPublicationVersionsPostUploadAttachment {
    ignore_report: boolean
    title: string
    uploaded_file: string
}

export interface BodyPublicationAnnouncementReportsPostUploadAnnouncementPackageReport {
    uploaded_files: string[]
}

export interface BodyPublicationActReportsPostUploadActPackageReport {
    uploaded_files: string[]
}

export type BodyAuthenticationPostAuthLoginAccessTokenGrantType = string | null

export type BodyAuthenticationPostAuthLoginAccessTokenClientSecret =
    | string
    | null

export type BodyAuthenticationPostAuthLoginAccessTokenClientId = string | null

export interface BodyAuthenticationPostAuthLoginAccessToken {
    client_id?: BodyAuthenticationPostAuthLoginAccessTokenClientId
    client_secret?: BodyAuthenticationPostAuthLoginAccessTokenClientSecret
    grant_type?: BodyAuthenticationPostAuthLoginAccessTokenGrantType
    password: string
    scope?: string
    username: string
}

export interface BillMetadata {
    Jurisdictions?: string[]
    Official_Title?: string
    Quote_Title?: string
    Subjects?: string[]
}

export type BillCompactMotivation = Motivation | null

export interface BillCompact {
    Amendment_Appendix?: AmendmentAppendix
    Amendment_Article?: string
    Appendices?: Appendix[]
    Closing?: string
    Custom_Articles?: Article[]
    Motivation?: BillCompactMotivation
    Preamble?: string
    Signed?: string
    Time_Article?: string
}

export interface BeleidsregelUUID {
    Object_ID?: number
    UUID?: string
}

export type BeleidsregelStaticStaticsPortfolioHolder2 = UserShort | null

export type BeleidsregelStaticStaticsPortfolioHolder1 = UserShort | null

export type BeleidsregelStaticStaticsOwner2 = UserShort | null

export type BeleidsregelStaticStaticsOwner1 = UserShort | null

export type BeleidsregelStaticStaticsClient1 = UserShort | null

export interface BeleidsregelStaticStatics {
    Client_1?: BeleidsregelStaticStaticsClient1
    Owner_1?: BeleidsregelStaticStaticsOwner1
    Owner_2?: BeleidsregelStaticStaticsOwner2
    Portfolio_Holder_1?: BeleidsregelStaticStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidsregelStaticStaticsPortfolioHolder2
}

export type BeleidsregelStaticPostStaticsPortfolioHolder2UUID = string | null

export type BeleidsregelStaticPostStaticsPortfolioHolder1UUID = string | null

export type BeleidsregelStaticPostStaticsOwner2UUID = string | null

export type BeleidsregelStaticPostStaticsOwner1UUID = string | null

export type BeleidsregelStaticPostStaticsClient1UUID = string | null

export interface BeleidsregelStaticPostStatics {
    Client_1_UUID?: BeleidsregelStaticPostStaticsClient1UUID
    Owner_1_UUID?: BeleidsregelStaticPostStaticsOwner1UUID
    Owner_2_UUID?: BeleidsregelStaticPostStaticsOwner2UUID
    Portfolio_Holder_1_UUID?: BeleidsregelStaticPostStaticsPortfolioHolder1UUID
    Portfolio_Holder_2_UUID?: BeleidsregelStaticPostStaticsPortfolioHolder2UUID
}

export type BeleidsregelPatchWeblink = string | null

export type BeleidsregelPatchTitle = string | null

export type BeleidsregelPatchDescription = string | null

export interface BeleidsregelPatch {
    Description?: BeleidsregelPatchDescription
    Title?: BeleidsregelPatchTitle
    Weblink?: BeleidsregelPatchWeblink
}

export interface BeleidsregelMinimal {
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type BeleidsregelFullStaticsPortfolioHolder2 = UserShort | null

export type BeleidsregelFullStaticsPortfolioHolder1 = UserShort | null

export type BeleidsregelFullStaticsOwner2 = UserShort | null

export type BeleidsregelFullStaticsOwner1 = UserShort | null

export type BeleidsregelFullStaticsClient1 = UserShort | null

export interface BeleidsregelFullStatics {
    Client_1?: BeleidsregelFullStaticsClient1
    Owner_1?: BeleidsregelFullStaticsOwner1
    Owner_2?: BeleidsregelFullStaticsOwner2
    Portfolio_Holder_1?: BeleidsregelFullStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidsregelFullStaticsPortfolioHolder2
}

export type BeleidsregelFullStartValidity = string | null

export type BeleidsregelFullNextVersion = NextObjectVersion | null

export type BeleidsregelFullModifiedBy = UserShort | null

export type BeleidsregelFullEndValidity = string | null

export type BeleidsregelFullCreatedBy = UserShort | null

export type BeleidsregelFullAdjustOn = string | null

export interface BeleidsregelFull {
    Adjust_On?: BeleidsregelFullAdjustOn
    Beleidskeuzes?: ReadRelationShortBeleidskeuzeMinimal[]
    Code?: string
    Created_By?: BeleidsregelFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: BeleidsregelFullEndValidity
    Modified_By?: BeleidsregelFullModifiedBy
    Modified_Date?: string
    Next_Version?: BeleidsregelFullNextVersion
    Object_ID?: number
    ObjectStatics?: BeleidsregelFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: BeleidsregelFullStartValidity
    Title?: string
    UUID?: string
    Weblink?: string
}

export type BeleidsregelExtendedStaticsPortfolioHolder2 = UserShort | null

export type BeleidsregelExtendedStaticsPortfolioHolder1 = UserShort | null

export type BeleidsregelExtendedStaticsOwner2 = UserShort | null

export type BeleidsregelExtendedStaticsOwner1 = UserShort | null

export type BeleidsregelExtendedStaticsClient1 = UserShort | null

export interface BeleidsregelExtendedStatics {
    Client_1?: BeleidsregelExtendedStaticsClient1
    Owner_1?: BeleidsregelExtendedStaticsOwner1
    Owner_2?: BeleidsregelExtendedStaticsOwner2
    Portfolio_Holder_1?: BeleidsregelExtendedStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidsregelExtendedStaticsPortfolioHolder2
}

export type BeleidsregelExtendedStartValidity = string | null

export type BeleidsregelExtendedModifiedBy = UserShort | null

export type BeleidsregelExtendedEndValidity = string | null

export type BeleidsregelExtendedCreatedBy = UserShort | null

export type BeleidsregelExtendedAdjustOn = string | null

export interface BeleidsregelExtended {
    Adjust_On?: BeleidsregelExtendedAdjustOn
    Code?: string
    Created_By?: BeleidsregelExtendedCreatedBy
    Created_Date?: string
    End_Validity?: BeleidsregelExtendedEndValidity
    Modified_By?: BeleidsregelExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: BeleidsregelExtendedStatics
    Start_Validity?: BeleidsregelExtendedStartValidity
    Title?: string
    UUID?: string
    Weblink?: string
}

export type BeleidsregelBasicStartValidity = string | null

export type BeleidsregelBasicNextVersion = NextObjectVersion | null

export type BeleidsregelBasicEndValidity = string | null

export type BeleidsregelBasicAdjustOn = string | null

export interface BeleidsregelBasic {
    Adjust_On?: BeleidsregelBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: BeleidsregelBasicEndValidity
    Modified_Date?: string
    Next_Version?: BeleidsregelBasicNextVersion
    Object_ID?: number
    Start_Validity?: BeleidsregelBasicStartValidity
    Title?: string
    UUID?: string
    Weblink?: string
}

export interface BeleidskeuzeUUID {
    Object_ID?: number
    UUID?: string
}

export type BeleidskeuzeStaticStaticsPortfolioHolder2 = UserShort | null

export type BeleidskeuzeStaticStaticsPortfolioHolder1 = UserShort | null

export type BeleidskeuzeStaticStaticsOwner2 = UserShort | null

export type BeleidskeuzeStaticStaticsOwner1 = UserShort | null

export type BeleidskeuzeStaticStaticsClient1 = UserShort | null

export interface BeleidskeuzeStaticStatics {
    Client_1?: BeleidskeuzeStaticStaticsClient1
    Owner_1?: BeleidskeuzeStaticStaticsOwner1
    Owner_2?: BeleidskeuzeStaticStaticsOwner2
    Portfolio_Holder_1?: BeleidskeuzeStaticStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidskeuzeStaticStaticsPortfolioHolder2
}

export type BeleidskeuzeStaticPostStaticsPortfolioHolder2UUID = string | null

export type BeleidskeuzeStaticPostStaticsPortfolioHolder1UUID = string | null

export type BeleidskeuzeStaticPostStaticsOwner2UUID = string | null

export type BeleidskeuzeStaticPostStaticsOwner1UUID = string | null

export type BeleidskeuzeStaticPostStaticsClient1UUID = string | null

export interface BeleidskeuzeStaticPostStatics {
    Client_1_UUID?: BeleidskeuzeStaticPostStaticsClient1UUID
    Owner_1_UUID?: BeleidskeuzeStaticPostStaticsOwner1UUID
    Owner_2_UUID?: BeleidskeuzeStaticPostStaticsOwner2UUID
    Portfolio_Holder_1_UUID?: BeleidskeuzeStaticPostStaticsPortfolioHolder1UUID
    Portfolio_Holder_2_UUID?: BeleidskeuzeStaticPostStaticsPortfolioHolder2UUID
}

export type BeleidskeuzePatchWerkingsgebiedCode = string | null

export type BeleidskeuzePatchTitle = string | null

export type BeleidskeuzePatchThemas = string[] | null

export type BeleidskeuzePatchProvincialInterest = string | null

export type BeleidskeuzePatchHierarchyCode = string | null

export type BeleidskeuzePatchGebiedengroepCode = string | null

export type BeleidskeuzePatchExplanation = string | null

export type BeleidskeuzePatchDescription = string | null

export type BeleidskeuzePatchCause = string | null

export interface BeleidskeuzePatch {
    Cause?: BeleidskeuzePatchCause
    Description?: BeleidskeuzePatchDescription
    Explanation?: BeleidskeuzePatchExplanation
    Gebiedengroep_Code?: BeleidskeuzePatchGebiedengroepCode
    Hierarchy_Code?: BeleidskeuzePatchHierarchyCode
    Provincial_Interest?: BeleidskeuzePatchProvincialInterest
    Themas?: BeleidskeuzePatchThemas
    Title?: BeleidskeuzePatchTitle
    Werkingsgebied_Code?: BeleidskeuzePatchWerkingsgebiedCode
}

export interface BeleidskeuzeMinimal {
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type BeleidskeuzeFullStaticsPortfolioHolder2 = UserShort | null

export type BeleidskeuzeFullStaticsPortfolioHolder1 = UserShort | null

export type BeleidskeuzeFullStaticsOwner2 = UserShort | null

export type BeleidskeuzeFullStaticsOwner1 = UserShort | null

export type BeleidskeuzeFullStaticsClient1 = UserShort | null

export interface BeleidskeuzeFullStatics {
    Client_1?: BeleidskeuzeFullStaticsClient1
    Owner_1?: BeleidskeuzeFullStaticsOwner1
    Owner_2?: BeleidskeuzeFullStaticsOwner2
    Portfolio_Holder_1?: BeleidskeuzeFullStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidskeuzeFullStaticsPortfolioHolder2
}

export type BeleidskeuzeFullWerkingsgebiedStatics = WerkingsgebiedStatics | null

export type BeleidskeuzeFullWerkingsgebied = WerkingsgebiedBasic | null

export type BeleidskeuzeFullStartValidity = string | null

export type BeleidskeuzeFullNextVersion = NextObjectVersion | null

export type BeleidskeuzeFullModifiedBy = UserShort | null

export type BeleidskeuzeFullHierarchyStatics = HierarchyStatics | null

export type BeleidskeuzeFullGebiedengroepStatic = ObjectStatics | null

export type BeleidskeuzeFullGebiedengroepCode = string | null

export type BeleidskeuzeFullEndValidity = string | null

export type BeleidskeuzeFullCreatedBy = UserShort | null

export type BeleidskeuzeFullAdjustOn = string | null

export interface BeleidskeuzeFull {
    Adjust_On?: BeleidskeuzeFullAdjustOn
    Beleidsdoelen?: ReadRelationShortBeleidsdoelMinimal[]
    Beleidsregels?: ReadRelationShortBeleidsregelMinimal[]
    Cause?: string
    Code?: string
    Created_By?: BeleidskeuzeFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: BeleidskeuzeFullEndValidity
    Explanation?: string
    Gebiedengroep_Code?: BeleidskeuzeFullGebiedengroepCode
    Gebiedengroep_Static?: BeleidskeuzeFullGebiedengroepStatic
    Gebiedsaanwijzingen_Statics?: ObjectStatics[]
    Hierarchy_Children?: HierachyReference[]
    Hierarchy_Code?: string
    Hierarchy_Statics?: BeleidskeuzeFullHierarchyStatics
    Maatregelen?: ReadRelationShortMaatregelMinimal[]
    Modified_By?: BeleidskeuzeFullModifiedBy
    Modified_Date?: string
    NationaleBelangen?: ReadRelationShortNationaalBelangMinimal[]
    Next_Version?: BeleidskeuzeFullNextVersion
    Object_ID?: number
    ObjectStatics?: BeleidskeuzeFullStatics
    Provincial_Interest?: string
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: BeleidskeuzeFullStartValidity
    Themas?: string[]
    Title?: string
    UUID?: string
    Werkingsgebied?: BeleidskeuzeFullWerkingsgebied
    Werkingsgebied_Code?: string
    Werkingsgebied_Statics?: BeleidskeuzeFullWerkingsgebiedStatics
    WettelijkeTaken?: ReadRelationShortWettelijkeTaakMinimal[]
}

export type BeleidskeuzeExtendedStaticsPortfolioHolder2 = UserShort | null

export type BeleidskeuzeExtendedStaticsPortfolioHolder1 = UserShort | null

export type BeleidskeuzeExtendedStaticsOwner2 = UserShort | null

export type BeleidskeuzeExtendedStaticsOwner1 = UserShort | null

export type BeleidskeuzeExtendedStaticsClient1 = UserShort | null

export interface BeleidskeuzeExtendedStatics {
    Client_1?: BeleidskeuzeExtendedStaticsClient1
    Owner_1?: BeleidskeuzeExtendedStaticsOwner1
    Owner_2?: BeleidskeuzeExtendedStaticsOwner2
    Portfolio_Holder_1?: BeleidskeuzeExtendedStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidskeuzeExtendedStaticsPortfolioHolder2
}

export type BeleidskeuzeExtendedStartValidity = string | null

export type BeleidskeuzeExtendedModifiedBy = UserShort | null

export type BeleidskeuzeExtendedGebiedengroepCode = string | null

export type BeleidskeuzeExtendedEndValidity = string | null

export type BeleidskeuzeExtendedCreatedBy = UserShort | null

export type BeleidskeuzeExtendedAdjustOn = string | null

export interface BeleidskeuzeExtended {
    Adjust_On?: BeleidskeuzeExtendedAdjustOn
    Code?: string
    Created_By?: BeleidskeuzeExtendedCreatedBy
    Created_Date?: string
    End_Validity?: BeleidskeuzeExtendedEndValidity
    Gebiedengroep_Code?: BeleidskeuzeExtendedGebiedengroepCode
    Hierarchy_Code?: string
    Modified_By?: BeleidskeuzeExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: BeleidskeuzeExtendedStatics
    Start_Validity?: BeleidskeuzeExtendedStartValidity
    Themas?: string[]
    Title?: string
    UUID?: string
    Werkingsgebied_Code?: string
}

export type BeleidskeuzeBasicStartValidity = string | null

export type BeleidskeuzeBasicNextVersion = NextObjectVersion | null

export type BeleidskeuzeBasicEndValidity = string | null

export type BeleidskeuzeBasicAdjustOn = string | null

export interface BeleidskeuzeBasic {
    Adjust_On?: BeleidskeuzeBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: BeleidskeuzeBasicEndValidity
    Modified_Date?: string
    Next_Version?: BeleidskeuzeBasicNextVersion
    Object_ID?: number
    Start_Validity?: BeleidskeuzeBasicStartValidity
    Title?: string
    UUID?: string
}

export interface BeleidsdoelUUID {
    Object_ID?: number
    UUID?: string
}

export type BeleidsdoelStaticStaticsPortfolioHolder2 = UserShort | null

export type BeleidsdoelStaticStaticsPortfolioHolder1 = UserShort | null

export type BeleidsdoelStaticStaticsOwner2 = UserShort | null

export type BeleidsdoelStaticStaticsOwner1 = UserShort | null

export type BeleidsdoelStaticStaticsClient1 = UserShort | null

export interface BeleidsdoelStaticStatics {
    Client_1?: BeleidsdoelStaticStaticsClient1
    Owner_1?: BeleidsdoelStaticStaticsOwner1
    Owner_2?: BeleidsdoelStaticStaticsOwner2
    Portfolio_Holder_1?: BeleidsdoelStaticStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidsdoelStaticStaticsPortfolioHolder2
}

export type BeleidsdoelStaticPostStaticsPortfolioHolder2UUID = string | null

export type BeleidsdoelStaticPostStaticsPortfolioHolder1UUID = string | null

export type BeleidsdoelStaticPostStaticsOwner2UUID = string | null

export type BeleidsdoelStaticPostStaticsOwner1UUID = string | null

export type BeleidsdoelStaticPostStaticsClient1UUID = string | null

export interface BeleidsdoelStaticPostStatics {
    Client_1_UUID?: BeleidsdoelStaticPostStaticsClient1UUID
    Owner_1_UUID?: BeleidsdoelStaticPostStaticsOwner1UUID
    Owner_2_UUID?: BeleidsdoelStaticPostStaticsOwner2UUID
    Portfolio_Holder_1_UUID?: BeleidsdoelStaticPostStaticsPortfolioHolder1UUID
    Portfolio_Holder_2_UUID?: BeleidsdoelStaticPostStaticsPortfolioHolder2UUID
}

export type BeleidsdoelPatchTitle = string | null

export type BeleidsdoelPatchThemas = string[] | null

export type BeleidsdoelPatchHierarchyCode = string | null

export type BeleidsdoelPatchDescription = string | null

export interface BeleidsdoelPatch {
    Description?: BeleidsdoelPatchDescription
    Hierarchy_Code?: BeleidsdoelPatchHierarchyCode
    Themas?: BeleidsdoelPatchThemas
    Title?: BeleidsdoelPatchTitle
}

export interface BeleidsdoelMinimal {
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type BeleidsdoelFullStaticsPortfolioHolder2 = UserShort | null

export type BeleidsdoelFullStaticsPortfolioHolder1 = UserShort | null

export type BeleidsdoelFullStaticsOwner2 = UserShort | null

export type BeleidsdoelFullStaticsOwner1 = UserShort | null

export type BeleidsdoelFullStaticsClient1 = UserShort | null

export interface BeleidsdoelFullStatics {
    Client_1?: BeleidsdoelFullStaticsClient1
    Owner_1?: BeleidsdoelFullStaticsOwner1
    Owner_2?: BeleidsdoelFullStaticsOwner2
    Portfolio_Holder_1?: BeleidsdoelFullStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidsdoelFullStaticsPortfolioHolder2
}

export type BeleidsdoelFullStartValidity = string | null

export type BeleidsdoelFullNextVersion = NextObjectVersion | null

export type BeleidsdoelFullModifiedBy = UserShort | null

export type BeleidsdoelFullHierarchyStatics = HierarchyStatics | null

export type BeleidsdoelFullEndValidity = string | null

export type BeleidsdoelFullCreatedBy = UserShort | null

export type BeleidsdoelFullAdjustOn = string | null

export interface BeleidsdoelFull {
    Adjust_On?: BeleidsdoelFullAdjustOn
    Ambities?: ReadRelationShortAmbitieMinimal[]
    Beleidskeuzes?: ReadRelationShortBeleidskeuzeMinimal[]
    Code?: string
    Created_By?: BeleidsdoelFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: BeleidsdoelFullEndValidity
    Gebiedsaanwijzingen_Statics?: ObjectStatics[]
    Hierarchy_Children?: HierachyReference[]
    Hierarchy_Code?: string
    Hierarchy_Statics?: BeleidsdoelFullHierarchyStatics
    Modified_By?: BeleidsdoelFullModifiedBy
    Modified_Date?: string
    Next_Version?: BeleidsdoelFullNextVersion
    Object_ID?: number
    ObjectStatics?: BeleidsdoelFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: BeleidsdoelFullStartValidity
    Themas?: string[]
    Title?: string
    UUID?: string
}

export type BeleidsdoelExtendedStaticsPortfolioHolder2 = UserShort | null

export type BeleidsdoelExtendedStaticsPortfolioHolder1 = UserShort | null

export type BeleidsdoelExtendedStaticsOwner2 = UserShort | null

export type BeleidsdoelExtendedStaticsOwner1 = UserShort | null

export type BeleidsdoelExtendedStaticsClient1 = UserShort | null

export interface BeleidsdoelExtendedStatics {
    Client_1?: BeleidsdoelExtendedStaticsClient1
    Owner_1?: BeleidsdoelExtendedStaticsOwner1
    Owner_2?: BeleidsdoelExtendedStaticsOwner2
    Portfolio_Holder_1?: BeleidsdoelExtendedStaticsPortfolioHolder1
    Portfolio_Holder_2?: BeleidsdoelExtendedStaticsPortfolioHolder2
}

export type BeleidsdoelExtendedStartValidity = string | null

export type BeleidsdoelExtendedModifiedBy = UserShort | null

export type BeleidsdoelExtendedEndValidity = string | null

export type BeleidsdoelExtendedCreatedBy = UserShort | null

export type BeleidsdoelExtendedAdjustOn = string | null

export interface BeleidsdoelExtended {
    Adjust_On?: BeleidsdoelExtendedAdjustOn
    Code?: string
    Created_By?: BeleidsdoelExtendedCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: BeleidsdoelExtendedEndValidity
    Hierarchy_Code?: string
    Modified_By?: BeleidsdoelExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: BeleidsdoelExtendedStatics
    Start_Validity?: BeleidsdoelExtendedStartValidity
    Themas?: string[]
    Title?: string
    UUID?: string
}

export type BeleidsdoelBasicStartValidity = string | null

export type BeleidsdoelBasicNextVersion = NextObjectVersion | null

export type BeleidsdoelBasicEndValidity = string | null

export type BeleidsdoelBasicAdjustOn = string | null

export interface BeleidsdoelBasic {
    Adjust_On?: BeleidsdoelBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: BeleidsdoelBasicEndValidity
    Modified_Date?: string
    Next_Version?: BeleidsdoelBasicNextVersion
    Object_ID?: number
    Start_Validity?: BeleidsdoelBasicStartValidity
    Title?: string
    UUID?: string
}

export interface AuthToken {
    access_token: string
    identifier: UserLoginDetail
    token_type: string
}

export interface AttachmentShort {
    Created_Date: string
    File_UUID: string
    Filename: string
    ID: number
    Modified_Date: string
    Title: string
}

export interface Article {
    Content: string
    Label?: string
    Number: string
}

export interface AreaBasic {
    Created_By_UUID: string
    Created_Date: string
    Source_Created_Date: string
    Source_Title: string
    Source_UUID: string
    UUID: string
}

export interface Appendix {
    Content: string
    Number: string
    Title: string
}

export type AnnouncementTextTitle = string | null

export interface AnnouncementText {
    Description: string
    Title: AnnouncementTextTitle
}

export type AnnouncementProceduralProceduralAnnouncementDate = string | null

export type AnnouncementProceduralEndInspectionPeriodDate = string | null

export type AnnouncementProceduralBeginInspectionPeriodDate = string | null

export interface AnnouncementProcedural {
    Begin_Inspection_Period_Date?: AnnouncementProceduralBeginInspectionPeriodDate
    End_Inspection_Period_Date?: AnnouncementProceduralEndInspectionPeriodDate
    Procedural_Announcement_Date?: AnnouncementProceduralProceduralAnnouncementDate
}

export interface AnnouncementMetadata {
    Official_Title?: string
    Subjects?: string[]
}

export interface AnnouncementCreatedResponse {
    UUID: string
}

export interface AnnouncementContent {
    Texts: AnnouncementText[]
}

export interface AmendmentAppendix {
    Number: string
    Title: string
}

export interface AmbitieUUID {
    Object_ID?: number
    UUID?: string
}

export type AmbitieStaticStaticsPortfolioHolder2 = UserShort | null

export type AmbitieStaticStaticsPortfolioHolder1 = UserShort | null

export type AmbitieStaticStaticsOwner2 = UserShort | null

export type AmbitieStaticStaticsOwner1 = UserShort | null

export type AmbitieStaticStaticsClient1 = UserShort | null

export interface AmbitieStaticStatics {
    Client_1?: AmbitieStaticStaticsClient1
    Owner_1?: AmbitieStaticStaticsOwner1
    Owner_2?: AmbitieStaticStaticsOwner2
    Portfolio_Holder_1?: AmbitieStaticStaticsPortfolioHolder1
    Portfolio_Holder_2?: AmbitieStaticStaticsPortfolioHolder2
}

export type AmbitieStaticPostStaticsPortfolioHolder2UUID = string | null

export type AmbitieStaticPostStaticsPortfolioHolder1UUID = string | null

export type AmbitieStaticPostStaticsOwner2UUID = string | null

export type AmbitieStaticPostStaticsOwner1UUID = string | null

export type AmbitieStaticPostStaticsClient1UUID = string | null

export interface AmbitieStaticPostStatics {
    Client_1_UUID?: AmbitieStaticPostStaticsClient1UUID
    Owner_1_UUID?: AmbitieStaticPostStaticsOwner1UUID
    Owner_2_UUID?: AmbitieStaticPostStaticsOwner2UUID
    Portfolio_Holder_1_UUID?: AmbitieStaticPostStaticsPortfolioHolder1UUID
    Portfolio_Holder_2_UUID?: AmbitieStaticPostStaticsPortfolioHolder2UUID
}

export type AmbitiePatchTitle = string | null

export type AmbitiePatchThemas = string[] | null

export type AmbitiePatchDescription = string | null

export interface AmbitiePatch {
    Description?: AmbitiePatchDescription
    Themas?: AmbitiePatchThemas
    Title?: AmbitiePatchTitle
}

export interface AmbitieMinimal {
    Object_ID?: number
    Object_Type?: string
    Title?: string
    UUID?: string
}

export type AmbitieFullStaticsPortfolioHolder2 = UserShort | null

export type AmbitieFullStaticsPortfolioHolder1 = UserShort | null

export type AmbitieFullStaticsOwner2 = UserShort | null

export type AmbitieFullStaticsOwner1 = UserShort | null

export type AmbitieFullStaticsClient1 = UserShort | null

export interface AmbitieFullStatics {
    Client_1?: AmbitieFullStaticsClient1
    Owner_1?: AmbitieFullStaticsOwner1
    Owner_2?: AmbitieFullStaticsOwner2
    Portfolio_Holder_1?: AmbitieFullStaticsPortfolioHolder1
    Portfolio_Holder_2?: AmbitieFullStaticsPortfolioHolder2
}

export type AmbitieFullStartValidity = string | null

export type AmbitieFullNextVersion = NextObjectVersion | null

export type AmbitieFullModifiedBy = UserShort | null

export type AmbitieFullEndValidity = string | null

export type AmbitieFullCreatedBy = UserShort | null

export type AmbitieFullAdjustOn = string | null

export interface AmbitieFull {
    Adjust_On?: AmbitieFullAdjustOn
    Beleidsdoelen?: ReadRelationShortBeleidsdoelMinimal[]
    Code?: string
    Created_By?: AmbitieFullCreatedBy
    Created_Date?: string
    Description?: string
    End_Validity?: AmbitieFullEndValidity
    Gebiedsaanwijzingen_Statics?: ObjectStatics[]
    Hierarchy_Children?: HierachyReference[]
    Modified_By?: AmbitieFullModifiedBy
    Modified_Date?: string
    Next_Version?: AmbitieFullNextVersion
    Object_ID?: number
    ObjectStatics?: AmbitieFullStatics
    Public_Revisions?: PublicModuleObjectRevision[]
    Start_Validity?: AmbitieFullStartValidity
    Themas?: string[]
    Title?: string
    UUID?: string
}

export type AmbitieExtendedStaticsPortfolioHolder2 = UserShort | null

export type AmbitieExtendedStaticsPortfolioHolder1 = UserShort | null

export type AmbitieExtendedStaticsOwner2 = UserShort | null

export type AmbitieExtendedStaticsOwner1 = UserShort | null

export type AmbitieExtendedStaticsClient1 = UserShort | null

export interface AmbitieExtendedStatics {
    Client_1?: AmbitieExtendedStaticsClient1
    Owner_1?: AmbitieExtendedStaticsOwner1
    Owner_2?: AmbitieExtendedStaticsOwner2
    Portfolio_Holder_1?: AmbitieExtendedStaticsPortfolioHolder1
    Portfolio_Holder_2?: AmbitieExtendedStaticsPortfolioHolder2
}

export type AmbitieExtendedStartValidity = string | null

export type AmbitieExtendedModifiedBy = UserShort | null

export type AmbitieExtendedEndValidity = string | null

export type AmbitieExtendedCreatedBy = UserShort | null

export type AmbitieExtendedAdjustOn = string | null

export interface AmbitieExtended {
    Adjust_On?: AmbitieExtendedAdjustOn
    Code?: string
    Created_By?: AmbitieExtendedCreatedBy
    Created_Date?: string
    End_Validity?: AmbitieExtendedEndValidity
    Modified_By?: AmbitieExtendedModifiedBy
    Modified_Date?: string
    Object_ID?: number
    ObjectStatics?: AmbitieExtendedStatics
    Start_Validity?: AmbitieExtendedStartValidity
    Themas?: string[]
    Title?: string
    UUID?: string
}

export type AmbitieBasicStartValidity = string | null

export type AmbitieBasicNextVersion = NextObjectVersion | null

export type AmbitieBasicEndValidity = string | null

export type AmbitieBasicAdjustOn = string | null

export interface AmbitieBasic {
    Adjust_On?: AmbitieBasicAdjustOn
    Code?: string
    Created_Date?: string
    End_Validity?: AmbitieBasicEndValidity
    Modified_Date?: string
    Next_Version?: AmbitieBasicNextVersion
    Object_ID?: number
    Start_Validity?: AmbitieBasicStartValidity
    Title?: string
    UUID?: string
}

export type ActiveModuleObjectModuleID = number | null

export interface ActiveModuleObject {
    Modified_Date: string
    Module_ID?: ActiveModuleObjectModuleID
    Title: string
    UUID: string
}

export interface ActiveModuleObjectsResponse {
    Action: ModuleObjectActionFull
    Module: ModuleShort
    Module_Object: ActiveModuleObject
}

export interface ActMetadata {
    Jurisdictions?: string[]
    Official_Title?: string
    Quote_Title?: string
    Subjects?: string[]
}

export type ActEditTitle = string | null

export type ActEditMetadata = ActMetadata | null

export interface ActEdit {
    Metadata?: ActEditMetadata
    Title?: ActEditTitle
}

export interface ActCreatedResponse {
    UUID: string
}

export type ActCreateWorkOther = string | null

export interface ActCreate {
    Document_Type: DocumentType
    Environment_UUID: string
    Title: string
    Work_Other?: ActCreateWorkOther
}

export type AcknowledgedRelationSideTitle = string | null

export type AcknowledgedRelationSideExplanation = string | null

export type AcknowledgedRelationSideAcknowledgedByUUID = string | null

export type AcknowledgedRelationSideAcknowledged = string | null

export interface AcknowledgedRelationSide {
    Acknowledged?: AcknowledgedRelationSideAcknowledged
    Acknowledged_By_UUID?: AcknowledgedRelationSideAcknowledgedByUUID
    Explanation?: AcknowledgedRelationSideExplanation
    Object_ID: number
    Object_Type: string
    Title?: AcknowledgedRelationSideTitle
}

export type AcknowledgedRelationDenied = string | null

export type AcknowledgedRelationDeletedAt = string | null

export interface AcknowledgedRelation {
    Created_By_UUID: string
    Created_Date: string
    Deleted_At?: AcknowledgedRelationDeletedAt
    Denied?: AcknowledgedRelationDenied
    Modified_By_UUID: string
    Modified_Date: string
    Requested_By_Code: string
    Side_A: AcknowledgedRelationSide
    Side_B: AcknowledgedRelationSide
    Version: number
}

export interface AbortResponse {
    new_state_uuid: string
}

export interface AOJCreatedResponse {
    UUID: string
}

export interface AOJCreate {
    Administrative_Borders_Date: string
    /** @minLength 3 */
    Administrative_Borders_Domain: string
    /** @minLength 3 */
    Administrative_Borders_ID: string
}
